


const bufferSize = 4096;

const mapExp = function (x, a) {
    return (Math.exp(x * a) - Math.exp(0)) / (Math.exp(a) - Math.exp(0))
}

const reverseMapExp = function (x, a) {
    return Math.log(x * (Math.exp(a) - Math.exp(0)) + Math.exp(0)) / a
}

const upsample = function (y, numPoints) {
    var m, b
    var x, interpX, interpXStep = (y.length - 1) / (numPoints - 1), i
    var interpY = new Float32Array(numPoints)

    i = 0
    interpX = 0
    for (x = 0; x < y.length - 1; x++) {
        m = (y[x + 1] - y[x])
        b = y[x] - m * x

        while (interpX <= x + 1) {
            interpY[i++] = m * interpX + b
            interpX += interpXStep
        }
    }

    return interpY
}

const round = function (val, decimal) {
    return Math.round(val * Math.pow(10, decimal)) / Math.pow(10, decimal)
}

// HRTF panner (hrtf-panner-js by twoz) — lazy-load vendor script + HRIR once, shared across instances
let _hrtfScriptPromise = null
function loadHrtfScript() {
    if (_hrtfScriptPromise) return _hrtfScriptPromise
    _hrtfScriptPromise = new Promise((resolve, reject) => {
        if (typeof window !== 'undefined' && typeof window.HRTFContainer !== 'undefined') return resolve()
        const s = document.createElement('script')
        s.src = '/js/hrtf.js'
        s.onload = () => resolve()
        s.onerror = () => reject(new Error('failed to load /js/hrtf.js'))
        document.head.appendChild(s)
    })
    return _hrtfScriptPromise
}

let _hrtfContainerPromise = null
function loadHrtfContainer() {
    if (_hrtfContainerPromise) return _hrtfContainerPromise
    _hrtfContainerPromise = loadHrtfScript().then(() => {
        return new Promise((resolve, reject) => {
            const c = new window.HRTFContainer()
            let done = false
            c.loadHrir('/js/hrir/kemar.bin', () => { done = true; resolve(c) })
            setTimeout(() => { if (!done) reject(new Error('HRIR load timeout')) }, 20000)
        })
    })
    return _hrtfContainerPromise
}

// binauralFIR (Ircam-RnD) — lazy-load vendor script + IRCAM HRTF dataset once, shared across instances
// Note: IRCAM HRTF data is public-domain for research/educational use; contact IRCAM for commercial use.
let _binauralFirScriptPromise = null
function loadBinauralFirScript() {
    if (_binauralFirScriptPromise) return _binauralFirScriptPromise
    _binauralFirScriptPromise = new Promise((resolve, reject) => {
        if (typeof window !== 'undefined' && typeof window.BinauralFIR !== 'undefined') return resolve()
        const s = document.createElement('script')
        s.src = '/js/binaural-fir.js'
        s.onload = () => resolve()
        s.onerror = () => reject(new Error('failed to load /js/binaural-fir.js'))
        document.head.appendChild(s)
    })
    return _binauralFirScriptPromise
}

let _ircamHrtfsPromise = null
function loadIrcamHrtfs() {
    if (_ircamHrtfsPromise) return _ircamHrtfsPromise
    _ircamHrtfsPromise = loadBinauralFirScript().then(() => {
        return new Promise((resolve, reject) => {
            if (typeof window !== 'undefined' && window.hrtfs && window.hrtfs.length) return resolve(window.hrtfs)
            const s = document.createElement('script')
            s.src = '/js/ircam-hrtfs.js'
            s.onload = () => {
                if (window.hrtfs && window.hrtfs.length) resolve(window.hrtfs)
                else reject(new Error('IRCAM HRTFs failed to populate'))
            }
            s.onerror = () => reject(new Error('failed to load /js/ircam-hrtfs.js'))
            document.head.appendChild(s)
        })
    })
    return _ircamHrtfsPromise
}

//  biquad filter control
// changeFilter(frequency,quality){
//     // Clamp the frequency between the minimum value (40 Hz) and half of the sampling rate.
//     let minValue = 40;
//     let maxValue = window.AudioFXGlobal.context.sampleRate / 2;
//     // Logarithm (base 2) to compute how many octaves fall in the range.
//     let numberOfOctaves = Math.log(maxValue / minValue) / Math.LN2;
//     // Compute a multiplier from 0 to 1 based on an exponential scale.
//     let multiplier = Math.pow(2, numberOfOctaves * (frequency - 1.0));
//     // Get back to the frequency value between min and max.
//     this.filterNode.frequency.value = maxValue * multiplier;
//     this.filterNode.Q.value = quality * this.const.QUALITY_MULTIPLIER;
//     // return for chaining
//     return this;
//   }


// 

const lib = {

    room: (audioctx, inputs) => {


        let input = audioctx.createGain();
        let output = audioctx.createGain();
        let reverbdry = audioctx.createGain();
        let reverbwet = audioctx.createGain();
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        let convolver = audioctx.createConvolver();
        async function setBuffer(name) {

            const raw = await fetch('/amenpi/impulses/' + name)
            const buffer = await raw.arrayBuffer()
            const audiobuffer = await audioctx.decodeAudioData(buffer)


            convolver.buffer = audiobuffer
        }

        inputs['type'].addEventListener('change', () => {
            setBuffer(inputs['type'].value)
        })
        setBuffer(inputs['type'].value)
        input.connect(convolver)
        input.connect(reverbdry)
        convolver.connect(reverbwet)
        reverbdry.connect(output)
        reverbwet.connect(output)
        updator.onaudioprocess = () => {
            if (reverbdry) {
                reverbdry.gain.setValueAtTime(1 - inputs['dry_wet'].value, audioctx.currentTime)
            }
            if (reverbwet) {
                reverbwet.gain.setValueAtTime(inputs['dry_wet'].value, audioctx.currentTime)
            }
        }

        return {
            input: input,
            output: output,
            params: {
                'dry_wet': [
                    { node: reverbdry.gain, transform: v => 1 - v },
                    { node: reverbwet.gain, transform: v => v },
                ],
            },
            destroy: () => {
                updator.disconnect()
                sink.disconnect()
                sink = null
                updator = null
                input.disconnect()
                output.disconnect()
                convolver.disconnect()
                reverbdry.disconnect()
                reverbwet.disconnect()

                input = null
                output = null
                convolver = null
                reverbwet = null
                reverbdry = null


            }
        }

    },

    gain: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        let gain = audioctx.createGain()
        sink.gain.value = 0
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        gain.gain.value = 0
        input.connect(gain)
        gain.connect(output)

      
        updator.onaudioprocess = () => {
            if (gain) {
                gain.gain.setValueAtTime( inputs['gain'].value, audioctx.currentTime)
            }
            
        }

        return {
            input: input,
            output: output,
            params: {
                'gain': { node: gain.gain, transform: v => v },
            },
            destroy: () => {
                updator.disconnect()
                sink.disconnect()
                sink = null
                updator = null
                input.disconnect()
                output.disconnect()
              gain.disconnect()

                input = null
                output = null
               


            }
        }

    },

    compressor: (audioctx, inputs) => {
        let compressor = audioctx.createDynamicsCompressor()
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        input.connect(compressor)
        compressor.connect(output)

        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        updator.onaudioprocess = () => {
            if (compressor) {
                compressor.threshold.setValueAtTime(0 - Number(inputs['threshold'].value), audioctx.currentTime)
                compressor.knee.setValueAtTime(Number(inputs['knee'].value), audioctx.currentTime)
                compressor.ratio.setValueAtTime(Number(inputs['ratio'].value), audioctx.currentTime)
                compressor.attack.setValueAtTime(Number(inputs['attack'].value), audioctx.currentTime)
                compressor.release.setValueAtTime(Number(inputs['release'].value), audioctx.currentTime)
            }
        }

        return {
            input: input,
            output: output,
            params: {
                'threshold': { node: compressor.threshold, transform: v => 0 - Number(v) },
                'knee': { node: compressor.knee, transform: v => Number(v) },
                'ratio': { node: compressor.ratio, transform: v => Number(v) },
                'attack': { node: compressor.attack, transform: v => Number(v) },
                'release': { node: compressor.release, transform: v => Number(v) },
            },
            destroy: () => {
                updator.disconnect()
                sink.disconnect()
                input.disconnect()
                output.disconnect()
                compressor.disconnect()
                updator = null
                sink = null
                input = null
                output = null
                compressor = null
            }
        }
    },

    stretch: (audioctx, inputs) => {
        let ratio = 1 + mapExp(inputs['stretch'].value, 10) * 999

        let blocksIn = []
        let blocksOut = []
        let batchSize = 4
        let winSize = 4096 * 4
        let input = audioctx.createGain()
        let output = audioctx.createGain()

        let paulstretchWorker = new Worker("/js/paulstretch-worker.js")
        let paulstretchNode = audioctx.createScriptProcessor(bufferSize, 1, 1)








        paulstretchWorker.postMessage({
            file: "/js/paulstretch.js",
            type: 'init',
            winSize: winSize,
            ratio: 1,
            numberOfChannels: 1,
            blockSize: bufferSize,
            batchSize: batchSize,
        })


        paulstretchWorker.onmessage = (event) => {
            // Add all the blocks from the batch to the `blocksOut` queue.
            if (event.data.type === 'read') {
                let blocks = event.data.data
                while (blocks.length) blocksOut.push(blocks.shift())
            }
        }


        paulstretchNode.onaudioprocess = (event) => {
            ratio = 1 + mapExp(inputs['stretch'].value, 10) * 999
            paulstretchWorker.postMessage({ type: 'config', ratio: ratio })
            var ch, block = []
            // Add every incoming block to the `blocksIn` queue

            block.push(event.inputBuffer.getChannelData(0))
            blocksIn.push(block)

            // If there is any processed block, read it ...
            if (blocksOut.length) {
                block = blocksOut.shift()

                event.outputBuffer.getChannelData(0).set(block[0])
            }

            if (blocksIn.length) {
                paulstretchWorker.postMessage({ type: 'write', data: blocksIn.shift() })
            }


            if (blocksOut.length < batchSize) {
                paulstretchWorker.postMessage({ type: 'read' })
            }


        }


        input.connect(paulstretchNode)
        paulstretchNode.connect(output)


        return {
            input,
            output,
            destroy: () => {

                input.disconnect()
                input = null
                output.disconnect()
                output = null

                paulstretchNode.disconnect()
                paulstretchNode = null


            }
        }


    },
    filter: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        let filter = audioctx.createBiquadFilter()
        filter.type = inputs["mode"].value
        sink.gain.value = 0
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        const minValue = 40;
        const maxValue = 44100 / 2;
        const numberOfOctaves = Math.log(maxValue / minValue) / Math.LN2;
        updator.onaudioprocess = () => {
            if (filter) {
                const multiplier = Math.pow(2, numberOfOctaves * (inputs['frequency'].value - 1.0));
                filter.frequency.setValueAtTime(maxValue * multiplier, audioctx.currentTime)
                filter.Q.setValueAtTime(inputs['q'].value * 30, audioctx.currentTime)
            }

        }

        inputs["mode"].addEventListener('change', () => {
            filter.type = inputs["mode"].value
        })
        input.connect(filter)
        filter.connect(output)
        return {
            input,
            output,
            params: {
                'frequency': { node: filter.frequency, transform: v => maxValue * Math.pow(2, numberOfOctaves * (v - 1.0)) },
                'q': { node: filter.Q, transform: v => v * 30 },
            },
            destroy: () => {

                input.disconnect()
                input = null
                output.disconnect()
                output = null
                filter.disconnect()
                filter = null
                sink.disconnect()
                sink = null
                updator.disconnect()
                updator = null

            }
        }
    },
    tremolo: (audioctx, inputs) => {


        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let gain = audioctx.createGain()
        let osc = audioctx.createOscillator()
        osc.type = "sine"
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        let shaper = audioctx.createWaveShaper()
        shaper.curve = new Float32Array([0, 1])
        sink.gain.value = 0
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        osc.connect(shaper)
        shaper.connect(gain.gain)
        input.connect(gain)
        gain.connect(output)
        updator.onaudioprocess = () => {
            if (osc) {
                shaper.curve = new Float32Array([1 - Number(inputs["depth"].value), 1])

                osc.frequency.setValueAtTime(Number(inputs["speed"].value), audioctx.currentTime)
            }

            //lGain.gain.setValueAtTime(inputs["low"].value, audioctx.currentTime)
            //mGain.gain.setValueAtTime(inputs["mid"].value, audioctx.currentTime)
            //hGain.gain.setValueAtTime(inputs["hi"].value, audioctx.currentTime)

        }

        osc.start()

        return {
            input,
            output,
            params: {
                'speed': { node: osc.frequency, transform: v => Number(v) },
            },
            destroy: () => {

                input.disconnect()
                input = null
                output.disconnect()
                output = null
                osc.disconnect()
                osc = null
                gain.disconnect()
                gain = null
                shaper.disconnect()
                shaper = null
                sink.disconnect()
                sink = null
                updator.disconnect()
                updator = null

            }
        }
    },
    pitshifter: (audioctx, inputs) => {
        const hannWindow = function (length) {

            const window = new Float32Array(length);
            for (let i = 0; i < length; i++) {
                window[i] = 0.5 * (1 - Math.cos(2 * Math.PI * i / (length - 1)));
            }
            return window;
        };

        const linearInterpolation = function (a, b, t) {
            return a + (b - a) * t;
        };

        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let pitchShifterProcessor
        function buildprocessor() {
            if (pitchShifterProcessor) {
                input.disconnect()
                pitchShifterProcessor.disconnect()
            }

            const grainSize = Number(inputs["grain"].value)
            pitchShifterProcessor = audioctx.createScriptProcessor(grainSize, 1, 1);
            const buffer = new Float32Array(grainSize * 2);
            const grainWindow = hannWindow(grainSize);
            pitchShifterProcessor.onaudioprocess = function (event) {
                let pitchRatio = Number(inputs["ratio"].value)
                let overlapRatio = Number(inputs["overlap"].value)
                const inputData = event.inputBuffer.getChannelData(0);
                const outputData = event.outputBuffer.getChannelData(0);

                for (i = 0; i < inputData.length; i++) {

                    // Apply the window to the input buffer
                    inputData[i] *= grainWindow[i];

                    // Shift half of the buffer
                    buffer[i] = buffer[i + grainSize];

                    // Empty the buffer tail
                    buffer[i + grainSize] = 0.0;
                }

                // Calculate the pitch shifted grain re-sampling and looping the input
                const grainData = new Float32Array(grainSize * 2);
                for (let i = 0, j = 0.0;
                    i < grainSize;
                    i++, j += pitchRatio) {

                    let index = Math.floor(j) % grainSize;
                    let a = inputData[index];
                    let b = inputData[(index + 1) % grainSize];
                    grainData[i] += linearInterpolation(a, b, j % 1.0) * grainWindow[i];
                }

                // Copy the grain multiple times overlapping it
                for (i = 0; i < grainSize; i += Math.round(grainSize * (1 - overlapRatio))) {
                    for (j = 0; j <= grainSize; j++) {
                        buffer[i + j] += grainData[j];
                    }
                }

                // Output the first half of the buffer
                for (i = 0; i < grainSize; i++) {
                    outputData[i] = buffer[i];
                }
            }
            input.connect(pitchShifterProcessor)
            pitchShifterProcessor.connect(output)
        }

        inputs["grain"].addEventListener('change', () => {
            buildprocessor()
        })
        buildprocessor()


        return {
            input,
            output,
            destroy: () => {
                input.disconnect()
                input = null
                output.disconnect()
                output = null
                pitchShifterProcessor.disconnect()
                pitchShifterProcessor = null

            }
        }

    },

    reverb: (audioctx, inputs) => {


        let input = audioctx.createGain();
        let output = audioctx.createGain();
        let reverbdry = audioctx.createGain();
        let reverbwet = audioctx.createGain();
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        let convolver = audioctx.createConvolver();
        async function setBuffer(name) {

            const raw = await fetch('/amenpi/impulses/' + name)
            const buffer = await raw.arrayBuffer()
            const audiobuffer = await audioctx.decodeAudioData(buffer)


            convolver.buffer = audiobuffer
        }

        inputs['type'].addEventListener('change', () => {
            setBuffer(inputs['type'].value)
        })
        setBuffer(inputs['type'].value)
        input.connect(convolver)
        input.connect(reverbdry)
        convolver.connect(reverbwet)
        reverbdry.connect(output)
        reverbwet.connect(output)
        updator.onaudioprocess = () => {
            if (reverbdry) {
                reverbdry.gain.setValueAtTime(1 - inputs['dry_wet'].value, audioctx.currentTime)
            }
            if (reverbwet) {
                reverbwet.gain.setValueAtTime(inputs['dry_wet'].value, audioctx.currentTime)
            }
        }

        return {
            input: input,
            output: output,
            params: {
                'dry_wet': [
                    { node: reverbdry.gain, transform: v => 1 - v },
                    { node: reverbwet.gain, transform: v => v },
                ],
            },
            destroy: () => {
                updator.disconnect()
                sink.disconnect()
                sink = null
                updator = null
                input.disconnect()
                output.disconnect()
                convolver.disconnect()
                reverbdry.disconnect()
                reverbwet.disconnect()

                input = null
                output = null
                convolver = null
                reverbwet = null
                reverbdry = null


            }
        }

    },
    eq: (audioctx, inputs) => {

        let input = audioctx.createGain();
        let output = audioctx.createGain();
        let gainDb = -40.0;
        let bandSplit = [360, 3600];
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        let hBand = audioctx.createBiquadFilter();
        hBand.type = "lowshelf";
        hBand.frequency.value = bandSplit[0];
        hBand.gain.value = gainDb;

        let hInvert = audioctx.createGain();
        hInvert.gain.value = -1.0;

        let mBand = audioctx.createGain();

        let lBand = audioctx.createBiquadFilter();
        lBand.type = "highshelf";
        lBand.frequency.value = bandSplit[1];
        lBand.gain.value = gainDb;

        var lInvert = audioctx.createGain();
        lInvert.gain.value = -1.0;

        input.connect(lBand);
        input.connect(mBand);
        input.connect(hBand);

        hBand.connect(hInvert);
        lBand.connect(lInvert);

        hInvert.connect(mBand);
        lInvert.connect(mBand);

        let lGain = audioctx.createGain();
        let mGain = audioctx.createGain();
        let hGain = audioctx.createGain();

        lBand.connect(lGain);
        mBand.connect(mGain);
        hBand.connect(hGain);

        let sum = audioctx.createGain();
        lGain.connect(sum);
        mGain.connect(sum);
        hGain.connect(sum);
        sum.connect(output)
        updator.onaudioprocess = () => {
            if (lGain) {
                lGain.gain.setValueAtTime(inputs["low"].value, audioctx.currentTime)
            }
            if (mGain) {
                mGain.gain.setValueAtTime(inputs["mid"].value, audioctx.currentTime)
            }
            if (hGain) {
                hGain.gain.setValueAtTime(inputs["hi"].value, audioctx.currentTime)
            }
        }
        return {
            input: input,
            output: output,
            params: {
                'low': { node: lGain.gain, transform: v => v },
                'mid': { node: mGain.gain, transform: v => v },
                'hi': { node: hGain.gain, transform: v => v },
            },
            destroy: () => {
                input.disconnect()
                output.disconnect()


                updator.disconnect()
                sink.disconnect()
                hBand.disconnect()
                mBand.disconnect()
                lBand.disconnect()
                hInvert.disconnect()
                lInvert.disconnect()
                lGain.disconnect()
                mGain.disconnect()
                hGain.disconnect()
                sum.disconnect()
                input = null
                output = null


                updator = null
                sink = null
                hBand = null
                mBand = null
                lBand = null
                hInvert = null
                lInvert = null
                lGain = null
                mGain = null
                hGain = null
                sum = null

            }
        }


    },

    softclipper: (audioctx, inputs) => {

            // Soft clipper function based on the provided formula
    function softClip(x, threshold,oversample =1) {

   

        const sign = Math.sign(x);
        const absX = Math.abs(x);
         threshold = Number(threshold)
         oversample = Number(oversample)
        const thresholdOversampled = threshold * oversample;
        const thresholdOversampledSquared = thresholdOversampled * thresholdOversampled;

        if (absX < thresholdOversampled) {
            return x;
        } else {
            return sign * (1 - (1 / (1 + Math.exp((absX - thresholdOversampled) / thresholdOversampledSquared)))) * threshold;
        }





    }
    

        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let processor = audioctx.createScriptProcessor(bufferSize, 2, 2)

        processor.onaudioprocess = function (evt) {

            const ib = evt.inputBuffer,
                ob = evt.outputBuffer;

            const id0 = ib.getChannelData(0),
                id1 = ib.getChannelData(1),
                od0 = ob.getChannelData(0),
                od1 = ob.getChannelData(1);

            for (let s = 0, l = ob.length; s < l; ++s) {
                od0[s] = softClip(id0[s], inputs["threshold"].value,inputs["oversample"].value)
                od1[s] = softClip(id1[s], inputs["threshold"].value,inputs["oversample"].value)
            }

        }

        input.connect(processor)
        processor.connect(output)
        return {
            input: input,
            output: output,
            destroy: () => {
                input.disconnect()
                output.disconnect()
                processor.disconnect()
                input = null
                output = null
                processor = null
            }
        }
    

     



    },


    chorus: (audioctx, inputs) => {


     
      
        const inputNode = audioContext.createGain();
      
        const outputNode = audioContext.createGain();
        const bufferSize = 4096;
        const delayTimes = [0.03, 0.045]; // Example delay times in seconds for two delay lines
        const modulationDepth = 0.005; // Example modulation depth in seconds
        const modulationRate = 2; // Example modulation rate in Hz
        
        let phase = 0;
 
        // Initialize delay line buffers
const delayBuffers = delayTimes.map(delayTime => {
    const bufferLength = Math.floor(delayTime * audioctx.sampleRate);
    return new Float32Array(bufferLength).fill(0);
  });

  
  const scriptNode = audioctx.createScriptProcessor(4096, 1, 1);

  // Connect nodes
 // Connect nodes
scriptNode.onaudioprocess = function(audioProcessingEvent) {
    const inputBuffer = audioProcessingEvent.inputBuffer.getChannelData(0);
    const outputBuffer = audioProcessingEvent.outputBuffer.getChannelData(0);
  
    for (let i = 0; i < inputBuffer.length; i++) {
      // Apply modulation to delay times
      const modulation = modulationDepth * Math.sin(2 * Math.PI * phase);
      phase += (modulationRate / audioctx.sampleRate);
      
      for (let j = 0; j < delayBuffers.length; j++) {
        // Calculate output from delay lines
        const delayBuffer = delayBuffers[j];
        const delayTime = delayTimes[j] * audioctx.sampleRate;
        const delayedSample = delayBuffer[Math.floor(delayBuffer.length - delayTime - modulation)];
        outputBuffer[i] += inputBuffer[i] + (delayedSample * 0.5); // Mix original and delayed samples
  
        // Apply feedback (optional)
        // outputBuffer[i] += some_feedback_processing;
        // Manually shift elements in the delay line
        for (let k = delayBuffer.length - 1; k >= 1; k--) {
          delayBuffer[k] = delayBuffer[k - 1];
        }
        delayBuffer[0] = outputBuffer[i]; // Set the first element as the current output
      }
  
      // Clip the output to prevent distortion
      outputBuffer[i] = Math.max(-1, Math.min(1, outputBuffer[i]));
    }
  }; 
        inputNode.connect(scriptNode);
        scriptNode.connect(outputNode);
     
        
        return {
            input: inputNode,
            output: outputNode,
            destroy: () => {
                inputNode.disconnect()
              
                outputNode.disconnect()

            }
        }



    },

    flanger: (audioctx, inputs) => {


        let inputNode = audioctx.createGain();
        let outputNode = audioctx.createGain();
        let inputFeedbackNode = audioctx.createGain();
        let wetGainNode = audioctx.createGain();
        let dryGainNode = audioctx.createGain();
        let delayNode = audioctx.createDelay();
        let oscillatorNode = audioctx.createOscillator();
        let gainNode = audioctx.createGain();
        let feedbackNode = audioctx.createGain();
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        let bypass = audioctx.createGain()
        sink.gain.value = 0
        oscillatorNode.type = 'sine';

        inputNode.connect(inputFeedbackNode);
        inputNode.connect(updator)
        inputNode.connect(bypass)
        updator.connect(sink)
        bypass.connect(outputNode)
        sink.connect(outputNode)
        inputNode.connect(dryGainNode);

        inputFeedbackNode.connect(delayNode);
        inputFeedbackNode.connect(wetGainNode);

        delayNode.connect(wetGainNode);
        delayNode.connect(feedbackNode);

        feedbackNode.connect(inputFeedbackNode);

        oscillatorNode.connect(gainNode);
        gainNode.connect(delayNode.delayTime);

        dryGainNode.connect(outputNode);
        wetGainNode.connect(outputNode);

        oscillatorNode.start(0);
        updator.onaudioprocess = () => {

            if (bypass) {
                bypass.gain.setValueAtTime(1 - inputs["dry_wet"].value, audioctx.currentTime)
            }
            if (dryGainNode) {
                dryGainNode.gain.setValueAtTime(inputs["dry_wet"].value, audioctx.currentTime)
            }
            if (wetGainNode) {
                wetGainNode.gain.setValueAtTime(inputs["dry_wet"].value, audioctx.currentTime)
            }
            if (feedbackNode) {
                feedbackNode.gain.setValueAtTime(inputs["feedback"].value, audioctx.currentTime)
            }
            if (gainNode) {
                gainNode.gain.setValueAtTime(inputs["depth"].value, audioctx.currentTime)
            }
            if (delayNode) {
                delayNode.delayTime.setValueAtTime(inputs["time"].value, audioctx.currentTime)
            }
            if (oscillatorNode) {
                oscillatorNode.frequency.setValueAtTime(inputs["speed"].value, audioctx.currentTime)
            }


        }



        return {
            input: inputNode,
            output: outputNode,
            params: {
                'dry_wet': [
                    { node: bypass.gain, transform: v => 1 - v },
                    { node: dryGainNode.gain, transform: v => v },
                    { node: wetGainNode.gain, transform: v => v },
                ],
                'feedback': { node: feedbackNode.gain, transform: v => v },
                'depth': { node: gainNode.gain, transform: v => v },
                'time': { node: delayNode.delayTime, transform: v => v },
                'speed': { node: oscillatorNode.frequency, transform: v => v },
            },
            destroy: () => {
                updator.disconnect()
                sink.disconnect()
                sink = null
                updator = null
                inputNode.disconnect();
                outputNode.disconnect();
                inputFeedbackNode.disconnect();
                wetGainNode.disconnect();
                dryGainNode.disconnect();
                delayNode.disconnect();
                oscillatorNode.disconnect();
                gainNode.disconnect();
                feedbackNode.disconnect();

                inputNode = null;
                outputNode = null;
                inputFeedbackNode = null;
                wetGainNode = null;
                dryGainNode = null;
                delayNode = null;
                oscillatorNode = null;
                gainNode = null;
                feedbackNode = null;
            }
        }

    },
    ringmodulator: (audioctx, inputs) => {
       
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let oscillator = audioctx.createOscillator()
        oscillator.type = inputs['waveform'].value
        oscillator.frequency.setValueAtTime(inputs['freq'].value, audioctx.currentTime)
        oscillator.channelCountMode = 'explicit';
        oscillator.channelCount = 1;

        // input 0 = source
        // input 1 = modulator
        let merger = audioctx.createChannelMerger(2);

        let processor = audioctx.createScriptProcessor(bufferSize, 3, 2);
        processor.onaudioprocess = function (evt) {


        
            oscillator.type = inputs['waveform'].value
            oscillator.frequency.setValueAtTime(inputs['freq'].value, audioctx.currentTime)
            const ib = evt.inputBuffer,
                ob = evt.outputBuffer;

            const id0 = ib.getChannelData(0),
                md = ib.getChannelData(1);
            // id1 = ib.getChannelData(1),
            const od0 = ob.getChannelData(0)
            const od1 = ob.getChannelData(1)
            //       

            for (let s = 0, l = ob.length; s < l; ++s) {
                //  od0[s] =id0[s] 
                //  od1[s] =id0[s] 
                od0[s] = id0[s] * md[s] * Number(inputs['depth'].value)
                od1[s] = id0[s] * md[s] * Number(inputs['depth'].value)
                //  if(s===0){
                //      console.log( od0[s] ,id0[s] , md[s])
                //  }
            }

        }
        input.connect(merger, 0, 0);

        oscillator.connect(merger, 0, 1);
        merger.connect(processor);
        processor.connect(output)

        oscillator.start(0)
        return {
            input: input,
            output: output,
            params: {
                'freq': { node: oscillator.frequency, transform: v => Number(v) },
            },
            destroy: () => {
                input.disconnect()
                output.disconnect()
                oscillator.disconnect()
                merger.disconnect()
                processor.disconnect()
                input = null
                output = null
                oscillator = null
                merger = null
                processor = null

            }
        }
    },
    distortion: (audioctx, inputs) => {

        function getCurve() {
            const k = Number(inputs["drive"].value) * 100
            const n = 22050
            const curve = new Float32Array(n)
            const deg = Math.PI / 180


            for (var i = 0; i < n; i++) {
                var x = i * 2 / n - 1;
                curve[i] = (3 + k) * x * 20 * deg / (Math.PI + k * Math.abs(x));

            }
            return curve
        }




        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1);
        let sink = audioctx.createGain()
        sink.gain.value = 0
        let distortionin = audioctx.createGain();
        let distortionout = audioctx.createGain();
        let distortion = audioctx.createWaveShaper();
        distortion.curve = getCurve()
        distortion.oversample = '4x';
        updator.onaudioprocess = () => {
            if (distortion) {
                distortion.curve = getCurve()
            }

        }
        distortionin.connect(distortion);
        distortion.connect(distortionout)
        distortionin.connect(updator)

        updator.connect(sink)

        sink.connect(distortionout)
        return {
            input: distortionin,
            output: distortionout,
            destroy: () => {

                updator.disconnect()
                sink.disconnect()
                distortionin.disconnect()
                distortionout.disconnect()
                distortion.disconnect()
                updator = null
                sink = null
                distortionin = null
                distortionout = null
                distortion = null

            }
        }

    },
    moog: (audioctx, inputs) => {

        let in1, in2, in3, in4, out1, out2, out3, out4;
        in1 = in2 = in3 = in4 = out1 = out2 = out3 = out4 = 0.0;

        let moog = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let input = audioctx.createGain()
        let output = audioctx.createGain()

        moog.onaudioprocess = (e) => {
            const input = e.inputBuffer.getChannelData(0);
            const output = e.outputBuffer.getChannelData(0);
            let f = Number(inputs["cutoff"].value) * 1.16;
            let fb = Number(inputs["resonance"].value) * (1.0 - 0.15 * f * f);
            for (let i = 0; i < bufferSize; i++) {
                input[i] -= out4 * fb;
                input[i] *= 0.35013 * (f * f) * (f * f);
                out1 = input[i] + 0.3 * in1 + (1 - f) * out1; // Pole 1
                in1 = input[i];
                out2 = out1 + 0.3 * in2 + (1 - f) * out2; // Pole 2
                in2 = out1;
                out3 = out2 + 0.3 * in3 + (1 - f) * out3; // Pole 3
                in3 = out2;
                out4 = out3 + 0.3 * in4 + (1 - f) * out4; // Pole 4
                in4 = out3;
                output[i] = out4;
            }
        }
        input.connect(moog)
        moog.connect(output)
        return {
            input: input,
            output: output,
            destroy: () => {
                input.disconnect()
                output.disconnect()
                moog.disconnect()
                input = null
                output = null
                moog = null
            }
        }

    },
    bitcrusher: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let crusher = audioctx.createScriptProcessor(bufferSize, 1, 1)
        crusher.onaudioprocess = (e) => {
            const inp = e.inputBuffer
            const out = e.outputBuffer
            const iL = inp.getChannelData(0)

            const oL = out.getChannelData(0)

            const step = Math.pow(0.5, Number(inputs["bits"].value) - 1)

            let sample = 0
            let lastL = 0
            // lastR = 0,

            for (let i = 0; i < inp.length; ++i) {
                if ((sample += Number(inputs["reduction"].value)) >= 1) {
                    sample--;
                    lastL = step * Math.floor(iL[i] / step)

                    //  lastR = step * Math.floor(iR[i] / step);
                }
                oL[i] = lastL;
                // oR[i] = lastR;
            }
        }
        input.connect(crusher)
        crusher.connect(output)
        return {
            input: input,
            output: output,
            destroy: () => {
                input.disconnect()
                output.disconnect()
                crusher.disconnect()
                input = null
                output = null
                crusher = null
            }
        }
    },
    delay: (audioctx, inputs) => {
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1);
        let delayin = audioctx.createGain();
        let delayout = audioctx.createGain();
        let delay = audioctx.createDelay();
        let sink = audioctx.createGain()
        sink.gain.value = 0

        let feedback = audioctx.createGain();

        let filterdelay = audioctx.createBiquadFilter();

        delay.delayTime.value = inputs["time"].value
        filterdelay.frequency.value = inputs["freq"].value
        feedback.gain.value = inputs["feedback"].value
        feedback.connect(filterdelay);
        filterdelay.connect(delay);
        delay.connect(feedback)
        delayin.connect(delay)
        delay.connect(delayout)
        delayin.connect(updator)
        updator.onaudioprocess = (e) => {
            if (delay) {
                delay.delayTime.value = inputs["time"].value

            }
            if (filterdelay) {
                filterdelay.frequency.value = inputs["freq"].value
            }
            if (feedback) {
                feedback.gain.value = inputs["feedback"].value
            }



        }
        updator.connect(sink)
        sink.connect(delayout)
        return {
            input: delayin,
            output: delayout,
            params: {
                'time': { node: delay.delayTime, transform: v => v },
                'freq': { node: filterdelay.frequency, transform: v => v },
                'feedback': { node: feedback.gain, transform: v => v },
            },
            destroy: () => {
                updator.disconnect()
                delayin.disconnect()
                delayout.disconnect()
                delay.disconnect()
                sink.disconnect()
                feedback.disconnect()
                filterdelay.disconnect()
                updator = null
                delayin = null
                delayout = null
                delay = null
                sink = null
                feedback = null
                filterdelay = null
            }
        }
    },

    autopanner: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let panner = audioctx.createStereoPanner()
        let lfo = audioctx.createOscillator()
        lfo.type = inputs['waveform'].value
        lfo.frequency.value = Number(inputs['rate'].value)
        let lfoGain = audioctx.createGain()
        lfoGain.gain.value = Number(inputs['depth'].value)
        input.connect(panner)
        panner.connect(output)
        lfo.connect(lfoGain)
        lfoGain.connect(panner.pan)
        lfo.start()
        inputs['rate'].addEventListener('change', () => {
            lfo.frequency.value = Number(inputs['rate'].value)
        })
        inputs['depth'].addEventListener('change', () => {
            lfoGain.gain.value = Number(inputs['depth'].value)
        })
        inputs['waveform'].addEventListener('change', (e) => {
            lfo.type = e.target.value
        })
        return {
            input: input,
            output: output,
            params: {
                'rate': { node: lfo.frequency, transform: v => Number(v) },
                'depth': { node: lfoGain.gain, transform: v => Number(v) },
            },
            destroy: () => {
                lfo.stop()
                lfo.disconnect()
                lfoGain.disconnect()
                input.disconnect()
                output.disconnect()
                panner.disconnect()
            }
        }
    },

    bitcrusherdisto: (audioctx, inputs) => {
        const WORKLET_NAME = 'bitcrusher-disto-drive'
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let workletNode = null
        const WORKLET_LOADED_FLAG = '__bitcrusherDistoDriveLoaded__'
        const workletSrc = `
        class BitcrusherDistoDriveProcessor extends AudioWorkletProcessor {
          static get parameterDescriptors() {
            return [
              {name:'bitDepth', defaultValue:8, minValue:1, maxValue:16, automationRate:'k-rate'},
              {name:'downsample', defaultValue:1, minValue:1, maxValue:32, automationRate:'k-rate'},
              {name:'drive', defaultValue:1, minValue:0, maxValue:10, automationRate:'k-rate'},
              {name:'mix', defaultValue:0.5, minValue:0, maxValue:1, automationRate:'k-rate'}
            ]
          }
          constructor() {
            super()
            this.phase = 0
            this.lastSample = 0
          }
          process(inputs, outputs, parameters) {
            const inChs = inputs[0] || []
            const outChs = outputs[0] || []
            if(!inChs.length || !outChs.length) return true
            const blockSize = inChs[0].length
            for(let ch=0; ch<outChs.length; ch++){
              const inCh = inChs[ch] || inChs[0]
              const outCh = outChs[ch]
              const bitDepth = parameters.bitDepth.length>0 ? parameters.bitDepth[0] : 8
              const downsample = parameters.downsample.length>0 ? parameters.downsample[0] : 1
              const drive = parameters.drive.length>0 ? parameters.drive[0] : 1
              const mix = parameters.mix.length>0 ? parameters.mix[0] : 0.5
              const step = Math.pow(0.5, bitDepth)
              for(let i=0;i<blockSize;i++){
                if(this.phase % Math.max(1,Math.floor(downsample)) === 0){
                  let s = inCh[i] || 0
                  s = Math.tanh(s * drive * 5)
                  s = Math.round(s/step)*step
                  this.lastSample = s
                }
                outCh[i] = this.lastSample * mix + (inCh[i] || 0) * (1-mix)
                this.phase++
              }
            }
            return true
          }
        }
        try{ registerProcessor('${WORKLET_NAME}', BitcrusherDistoDriveProcessor) }catch(e){}
        `
        const blobUrl = URL.createObjectURL(new Blob([workletSrc], {type:'application/javascript'}))
        const ensureWorklet = async () => {
            if(audioctx[WORKLET_LOADED_FLAG]) return
            await audioctx.audioWorklet.addModule(blobUrl)
            audioctx[WORKLET_LOADED_FLAG] = true
        }
        const ready = ensureWorklet().then(() => {
            workletNode = new AudioWorkletNode(audioctx, WORKLET_NAME, {
                numberOfInputs:1,
                numberOfOutputs:1,
                outputChannelCount:[2],
                parameterData:{
                    bitDepth: Number(inputs['bitDepth'] ? inputs['bitDepth'].value : 8),
                    downsample: Number(inputs['downsample'] ? inputs['downsample'].value : 1),
                    drive: Number(inputs['drive'] ? inputs['drive'].value : 1),
                    mix: Number(inputs['mix'] ? inputs['mix'].value : 0.5)
                }
            })
            input.connect(workletNode)
            workletNode.connect(output)
            ;['bitDepth','downsample','drive','mix'].forEach(id => {
                if(inputs[id]){
                    inputs[id].addEventListener('change', () => {
                        if(!workletNode) return
                        const p = workletNode.parameters.get(id)
                        if(p) p.setValueAtTime(Number(inputs[id].value), audioctx.currentTime)
                    })
                }
            })
        })
        return {
            input: input,
            output: output,
            ready: ready,
            params: {
                'bitDepth': { get node() { return workletNode ? workletNode.parameters.get('bitDepth') : null }, transform: v => Number(v) },
                'downsample': { get node() { return workletNode ? workletNode.parameters.get('downsample') : null }, transform: v => Number(v) },
                'drive': { get node() { return workletNode ? workletNode.parameters.get('drive') : null }, transform: v => Number(v) },
                'mix': { get node() { return workletNode ? workletNode.parameters.get('mix') : null }, transform: v => Number(v) },
            },
            destroy: () => {
                input.disconnect()
                output.disconnect()
                if(workletNode){ workletNode.disconnect(); workletNode = null }
                URL.revokeObjectURL(blobUrl)
                try{ delete audioctx[WORKLET_LOADED_FLAG] }catch(e){}
            }
        }
    },

    canalplus: (audioctx, inputs) => {
        const WORKLET_NAME = 'crypto-processor'
        let blobUrl = null
        let workletNode = null
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        const WORKLET_LOADED_FLAG = '__cryptoWorkletLoaded__'
        const workletSource = `
        class CryptoProcessor extends AudioWorkletProcessor {
          static get parameterDescriptors() {
            return [
              { name: 'mode', defaultValue: 0, minValue: 0, maxValue: 1, automationRate: 'k-rate' },
              { name: 'carrierFreq', defaultValue: 1200, minValue: 50, maxValue: 8000, automationRate: 'k-rate' },
              { name: 'gateRate', defaultValue: 40, minValue: 0.1, maxValue: 1000, automationRate: 'k-rate' },
              { name: 'gateDuty', defaultValue: 0.5, minValue: 0.01, maxValue: 0.99, automationRate: 'k-rate' },
              { name: 'decode', defaultValue: 0, minValue: 0, maxValue: 1, automationRate: 'k-rate' },
              { name: 'outGain', defaultValue: 0.9, minValue: 0, maxValue: 4, automationRate: 'k-rate' }
            ]
          }
          constructor() {
            super()
            this.sampleRate = sampleRate
            this.phase = 0
            this.gatePhase = 0
            this.firSize = 31
            this.prev = new Array(this.firSize).fill(0)
            this.prevIdx = 0
          }
          firLowpass(s) {
            this.prev[this.prevIdx] = s
            this.prevIdx = (this.prevIdx + 1) % this.firSize
            let sum = 0
            for (let i=0;i<this.firSize;i++) sum += this.prev[i]
            return sum / this.firSize
          }
          process(inputs, outputs, parameters) {
            const inChannels = inputs[0] || []
            const outChannels = outputs[0] || []
            if (!inChannels.length || !outChannels.length) return true
            const mode = parameters.mode.length>0 ? parameters.mode[0] : 0
            const carrierFreq = parameters.carrierFreq.length>0 ? parameters.carrierFreq[0] : 1200
            const gateRate = parameters.gateRate.length>0 ? parameters.gateRate[0] : 40
            const gateDuty = parameters.gateDuty.length>0 ? parameters.gateDuty[0] : 0.5
            const decode = parameters.decode.length>0 ? parameters.decode[0] : 0
            const outGain = parameters.outGain.length>0 ? parameters.outGain[0] : 0.9
            const twoPi = 2*Math.PI
            const blockSize = inChannels[0].length
            for (let i=0;i<blockSize;i++) {
              const t = this.phase/this.sampleRate
              const carrier = Math.cos(twoPi * carrierFreq * t)
              this.phase = (this.phase + 1) % this.sampleRate
              const gatePeriod = 1/Math.max(1e-6, gateRate)
              const gatePos = ((this.gatePhase/this.sampleRate) % gatePeriod)/gatePeriod
              const gateVal = (gatePos < gateDuty) ? 1 : 0
              this.gatePhase = (this.gatePhase + 1) % this.sampleRate
              for (let ch=0; ch<outChannels.length; ch++) {
                const inCh = inChannels[ch] || inChannels[0]
                const x = inCh ? inCh[i] || 0 : 0
                let y = 0
                if (mode < 0.5) {
                  if (!decode) {
                    y = x * carrier
                  } else {
                    const mixed = x * carrier
                    y = this.firLowpass(mixed)
                  }
                } else {
                  y = x * gateVal
                }
                if (outChannels[ch]) outChannels[ch][i] = y * outGain
              }
            }
            return true
          }
        }
        try{ registerProcessor('${WORKLET_NAME}', CryptoProcessor) }catch(e){}
        `
        const makeBlobUrl = src => URL.createObjectURL(new Blob([src], {type:'application/javascript'}))
        const ensureWorklet = async () => {
            if (audioctx[WORKLET_LOADED_FLAG]) return
            blobUrl = makeBlobUrl(workletSource)
            await audioctx.audioWorklet.addModule(blobUrl)
            audioctx[WORKLET_LOADED_FLAG] = true
        }
        const ready = ensureWorklet().then(() => {
            const paramData = {
                carrierFreq: Number(inputs['carrierFreq'] ? inputs['carrierFreq'].value : 1200),
                gateRate: Number(inputs['gateRate'] ? inputs['gateRate'].value : 40),
                gateDuty: Number(inputs['gateDuty'] ? Number(inputs['gateDuty'].value)/100 : 0.5),
                mode: Number(inputs['mode'] ? inputs['mode'].value : 0),
                decode: Number(inputs['decode'] ? inputs['decode'].value : 0),
                outGain: Number(inputs['outGain'] ? inputs['outGain'].value : 0.9)
            }
            workletNode = new AudioWorkletNode(audioctx, WORKLET_NAME, {
                numberOfInputs: 1,
                numberOfOutputs: 1,
                outputChannelCount: [2],
                parameterData: paramData
            })
            input.connect(workletNode)
            workletNode.connect(output)
            const setParam = (name, val) => {
                if (!workletNode) return
                const p = workletNode.parameters.get(name)
                if (p) p.setValueAtTime(Number(val), audioctx.currentTime)
            }
            ;['carrierFreq','gateRate','gateDuty','mode','decode','outGain'].forEach(id => {
                if (inputs[id]) inputs[id].addEventListener('change', () => {
                    let val = inputs[id].value
                    if(id==='gateDuty') val = Number(val)/100
                    setParam(id, val)
                })
            })
        }).catch(err => console.error('Worklet init error:', err))
        return {
            input: input,
            output: output,
            ready: ready,
            params: {
                'carrierFreq': { get node() { return workletNode ? workletNode.parameters.get('carrierFreq') : null }, transform: v => Number(v) },
                'gateRate': { get node() { return workletNode ? workletNode.parameters.get('gateRate') : null }, transform: v => Number(v) },
                'gateDuty': { get node() { return workletNode ? workletNode.parameters.get('gateDuty') : null }, transform: v => Number(v) / 100 },
                'mode': { get node() { return workletNode ? workletNode.parameters.get('mode') : null }, transform: v => Number(v) },
                'decode': { get node() { return workletNode ? workletNode.parameters.get('decode') : null }, transform: v => Number(v) },
                'outGain': { get node() { return workletNode ? workletNode.parameters.get('outGain') : null }, transform: v => Number(v) },
            },
            destroy: () => {
                try{ input.disconnect() }catch(e){}
                try{ if(workletNode){ workletNode.disconnect(); workletNode = null } }catch(e){}
                try{ output.disconnect() }catch(e){}
                if(blobUrl){ try{ URL.revokeObjectURL(blobUrl) }catch(e){} blobUrl = null }
                try{ delete audioctx[WORKLET_LOADED_FLAG] }catch(e){}
            }
        }
    },

    chorus1: (audioctx, inputs) => {
        const WORKLET_NAME = 'chorus-super-stereo'
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let workletNode = null
        const WORKLET_LOADED_FLAG = '__chorusSuperStereoLoaded__'
        const workletSrc = `
        class ChorusSuperStereoProcessor extends AudioWorkletProcessor {
          static get parameterDescriptors() {
            return [
              { name: 'depth', defaultValue: 5, minValue: 1, maxValue: 10, automationRate: 'k-rate' },
              { name: 'rate', defaultValue: 0.25, minValue: 0.01, maxValue: 5, automationRate: 'k-rate' },
              { name: 'mix', defaultValue: 0.5, minValue: 0, maxValue: 1, automationRate: 'k-rate' },
              { name: 'feedback', defaultValue: 0.05, minValue: 0, maxValue: 0.2, automationRate: 'k-rate' }
            ]
          }
          constructor() {
            super()
            this.sampleRate = sampleRate
            this.numVoices = 4
            this.baseDelayMs = 20
            this.bufferSize = Math.floor(this.sampleRate * 0.05)
            this.buffers = [
              Array.from({length:this.numVoices}, ()=>new Float32Array(this.bufferSize).fill(0)),
              Array.from({length:this.numVoices}, ()=>new Float32Array(this.bufferSize).fill(0))
            ]
            this.writeIndex = 0
            this.lfoPhase = [
              Array.from({length:this.numVoices}, (_,i)=>i*0.25),
              Array.from({length:this.numVoices}, (_,i)=>i*0.25 + 0.1)
            ]
          }
          process(inputs, outputs, parameters) {
            const inChs = inputs[0] || []
            const outChs = outputs[0] || []
            if(!inChs.length || !outChs.length) return true
            const blockSize = inChs[0].length
            const depthMs = parameters.depth.length>0 ? parameters.depth[0] : 5
            const rateHz = parameters.rate.length>0 ? parameters.rate[0] : 0.25
            const mix = parameters.mix.length>0 ? parameters.mix[0] : 0.5
            const feedback = parameters.feedback.length>0 ? parameters.feedback[0] : 0.05
            const depthSamples = depthMs * this.sampleRate / 1000
            const baseDelaySamples = this.baseDelayMs * this.sampleRate / 1000
            for(let i=0;i<blockSize;i++){
              for(let ch=0;ch<2;ch++){
                const inCh = inChs[ch] || inChs[0]
                const outCh = outChs[ch]
                const x = inCh[i] || 0
                let yTotal = 0
                for(let v=0;v<this.numVoices;v++){
                  const buf = this.buffers[ch][v]
                  let phase = this.lfoPhase[ch][v]
                  const lfoValue = (Math.sin(2*Math.PI*phase)+1)/2
                  const delaySamples = baseDelaySamples + lfoValue*depthSamples
                  let readIndex = (this.writeIndex - delaySamples + this.bufferSize) % this.bufferSize
                  const i0 = Math.floor(readIndex)
                  const i1 = (i0+1)%this.bufferSize
                  const frac = readIndex - i0
                  const y = buf[i0]*(1-frac) + buf[i1]*frac
                  yTotal += y
                  buf[this.writeIndex] = x + y*feedback
                  phase += rateHz/this.sampleRate
                  if(phase>=1) phase-=1
                  this.lfoPhase[ch][v] = phase
                }
                yTotal /= this.numVoices
                outCh[i] = x*(1-mix) + yTotal*mix
              }
              this.writeIndex = (this.writeIndex + 1)%this.bufferSize
            }
            return true
          }
        }
        try{ registerProcessor('${WORKLET_NAME}', ChorusSuperStereoProcessor) }catch(e){}
        `
        const blobUrl = URL.createObjectURL(new Blob([workletSrc], {type:'application/javascript'}))
        const ensureWorklet = async () => {
            if(audioctx[WORKLET_LOADED_FLAG]) return
            await audioctx.audioWorklet.addModule(blobUrl)
            audioctx[WORKLET_LOADED_FLAG] = true
        }
        const ready = ensureWorklet().then(() => {
            workletNode = new AudioWorkletNode(audioctx, WORKLET_NAME, {
                numberOfInputs:1,
                numberOfOutputs:1,
                outputChannelCount:[2],
                parameterData:{
                    depth: Number(inputs['depth'] ? inputs['depth'].value : 5),
                    rate: Number(inputs['rate'] ? inputs['rate'].value : 0.25),
                    mix: Number(inputs['mix'] ? inputs['mix'].value : 0.5),
                    feedback: Number(inputs['feedback'] ? inputs['feedback'].value : 0.05)
                }
            })
            input.connect(workletNode)
            workletNode.connect(output)
            ;['depth','rate','mix','feedback'].forEach(id => {
                if(inputs[id]){
                    inputs[id].addEventListener('change', () => {
                        if(!workletNode) return
                        const p = workletNode.parameters.get(id)
                        if(p) p.setValueAtTime(Number(inputs[id].value), audioctx.currentTime)
                    })
                }
            })
        })
        return {
            input: input,
            output: output,
            ready: ready,
            params: {
                'depth': { get node() { return workletNode ? workletNode.parameters.get('depth') : null }, transform: v => Number(v) },
                'rate': { get node() { return workletNode ? workletNode.parameters.get('rate') : null }, transform: v => Number(v) },
                'mix': { get node() { return workletNode ? workletNode.parameters.get('mix') : null }, transform: v => Number(v) },
                'feedback': { get node() { return workletNode ? workletNode.parameters.get('feedback') : null }, transform: v => Number(v) },
            },
            destroy: () => {
                input.disconnect()
                output.disconnect()
                if(workletNode){ workletNode.disconnect(); workletNode = null }
                URL.revokeObjectURL(blobUrl)
                try{ delete audioctx[WORKLET_LOADED_FLAG] }catch(e){}
            }
        }
    },

    dubdelay: (audioctx, inputs) => {
        let delayin = audioctx.createGain()
        let delayout = audioctx.createGain()
        let dryGain = audioctx.createGain()
        let wetGain = audioctx.createGain()
        let delay = audioctx.createDelay()
        let feedback = audioctx.createGain()
        let filterdelay = audioctx.createBiquadFilter()
        delay.delayTime.value = inputs['time'].value
        filterdelay.frequency.value = inputs['freq'].value
        filterdelay.type = inputs['filterType'].value
        feedback.gain.value = inputs['feedback'].value
        feedback.connect(filterdelay)
        filterdelay.connect(delay)
        delay.connect(feedback)
        delayin.connect(delay)
        delayin.connect(dryGain)
        delay.connect(wetGain)
        dryGain.connect(delayout)
        wetGain.connect(delayout)
        dryGain.gain.value = 1 - Number(inputs['dry_wet'].value)
        wetGain.gain.value = Number(inputs['dry_wet'].value)
        inputs['time'].addEventListener('change', () => {
            delay.delayTime.value = inputs['time'].value
        })
        inputs['freq'].addEventListener('change', () => {
            filterdelay.frequency.value = inputs['freq'].value
        })
        inputs['feedback'].addEventListener('change', () => {
            feedback.gain.value = inputs['feedback'].value
        })
        inputs['filterType'].addEventListener('change', (e) => {
            filterdelay.type = e.target.value
        })
        inputs['dry_wet'].addEventListener('change', () => {
            dryGain.gain.value = 1 - Number(inputs['dry_wet'].value)
            wetGain.gain.value = Number(inputs['dry_wet'].value)
        })
        return {
            input: delayin,
            output: delayout,
            params: {
                'time': { node: delay.delayTime, transform: v => v },
                'freq': { node: filterdelay.frequency, transform: v => v },
                'feedback': { node: feedback.gain, transform: v => v },
                'dry_wet': [
                    { node: dryGain.gain, transform: v => 1 - Number(v) },
                    { node: wetGain.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                delayin.disconnect()
                delayout.disconnect()
                dryGain.disconnect()
                wetGain.disconnect()
                delay.disconnect()
                feedback.disconnect()
                filterdelay.disconnect()
            }
        }
    },

    flanger2: (audioctx, inputs) => {
        const WORKLET_NAME = 'flanger-clean-stereo-fixed'
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let workletNode = null
        const WORKLET_LOADED_FLAG = '__flangerCleanStereoFixedLoaded__'
        const workletSrc = `
        class FlangerCleanStereoFixedProcessor extends AudioWorkletProcessor {
          static get parameterDescriptors() {
            return [
              { name: 'depth', defaultValue: 5, minValue: 1, maxValue: 10, automationRate: 'k-rate' },
              { name: 'rate', defaultValue: 0.25, minValue: 0.01, maxValue: 5, automationRate: 'k-rate' },
              { name: 'feedback', defaultValue: 0.3, minValue: 0, maxValue: 0.95, automationRate: 'k-rate' },
              { name: 'mix', defaultValue: 0.5, minValue: 0, maxValue: 1, automationRate: 'k-rate' }
            ]
          }
          constructor() {
            super()
            this.sampleRate = sampleRate
            this.bufferSize = Math.floor(this.sampleRate * 0.05)
            this.buffers = [new Float32Array(this.bufferSize).fill(0), new Float32Array(this.bufferSize).fill(0)]
            this.writeIndex = 0
            this.lfoPhase = [0, 0.25]
          }
          process(inputs, outputs, parameters) {
            const inChs = inputs[0] || []
            const outChs = outputs[0] || []
            if (!inChs.length || !outChs.length) return true
            const blockSize = inChs[0].length
            const depthMs = parameters.depth.length > 0 ? parameters.depth[0] : 5
            const rateHz = parameters.rate.length > 0 ? parameters.rate[0] : 0.25
            const feedback = parameters.feedback.length > 0 ? parameters.feedback[0] : 0.3
            const mix = parameters.mix.length > 0 ? parameters.mix[0] : 0.5
            const depthSamples = depthMs * this.sampleRate / 1000
            for (let i = 0; i < blockSize; i++) {
              for (let ch = 0; ch < 2; ch++) {
                const inCh = inChs[ch] || inChs[0]
                const outCh = outChs[ch]
                const buf = this.buffers[ch]
                const x = inCh[i] || 0
                const lfoValue = (Math.sin(2 * Math.PI * this.lfoPhase[ch]) + 1) / 2
                const delaySamples = lfoValue * depthSamples
                let readIndex = (this.writeIndex - delaySamples + this.bufferSize) % this.bufferSize
                const i0 = Math.floor(readIndex)
                const i1 = (i0 + 1) % this.bufferSize
                const frac = readIndex - i0
                const y = buf[i0] * (1 - frac) + buf[i1] * frac
                outCh[i] = x * (1 - mix) + y * mix
                buf[this.writeIndex] = x + y * feedback
                this.lfoPhase[ch] += rateHz / this.sampleRate
                if (this.lfoPhase[ch] >= 1) this.lfoPhase[ch] -= 1
              }
              this.writeIndex = (this.writeIndex + 1) % this.bufferSize
            }
            return true
          }
        }
        try{ registerProcessor('${WORKLET_NAME}', FlangerCleanStereoFixedProcessor) }catch(e){}
        `
        const blobUrl = URL.createObjectURL(new Blob([workletSrc], { type: 'application/javascript' }))
        const ensureWorklet = async () => {
            if (audioctx[WORKLET_LOADED_FLAG]) return
            await audioctx.audioWorklet.addModule(blobUrl)
            audioctx[WORKLET_LOADED_FLAG] = true
        }
        const ready = ensureWorklet().then(() => {
            workletNode = new AudioWorkletNode(audioctx, WORKLET_NAME, {
                numberOfInputs: 1,
                numberOfOutputs: 1,
                outputChannelCount: [2],
                parameterData: {
                    depth: Number(inputs['depth'] ? inputs['depth'].value : 5),
                    rate: Number(inputs['rate'] ? inputs['rate'].value : 0.25),
                    feedback: Number(inputs['feedback'] ? inputs['feedback'].value : 0.3),
                    mix: Number(inputs['mix'] ? inputs['mix'].value : 0.5)
                }
            })
            input.connect(workletNode)
            workletNode.connect(output)
            ;['depth', 'rate', 'feedback', 'mix'].forEach(id => {
                if (inputs[id]) {
                    inputs[id].addEventListener('change', () => {
                        if (!workletNode) return
                        const p = workletNode.parameters.get(id)
                        if (p) p.setValueAtTime(Number(inputs[id].value), audioctx.currentTime)
                    })
                }
            })
        })
        return {
            input: input,
            output: output,
            ready: ready,
            params: {
                'depth': { get node() { return workletNode ? workletNode.parameters.get('depth') : null }, transform: v => Number(v) },
                'rate': { get node() { return workletNode ? workletNode.parameters.get('rate') : null }, transform: v => Number(v) },
                'feedback': { get node() { return workletNode ? workletNode.parameters.get('feedback') : null }, transform: v => Number(v) },
                'mix': { get node() { return workletNode ? workletNode.parameters.get('mix') : null }, transform: v => Number(v) },
            },
            destroy: () => {
                input.disconnect()
                output.disconnect()
                if (workletNode) { workletNode.disconnect(); workletNode = null }
                URL.revokeObjectURL(blobUrl)
                try { delete audioctx[WORKLET_LOADED_FLAG] } catch (e) {}
            }
        }
    },

    frequencyshifter: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let wet = audioctx.createGain()
        let dry = audioctx.createGain()
        let delay = audioctx.createDelay(0.5)
        delay.delayTime.value = 0.05
        let lfo = audioctx.createOscillator()
        lfo.type = 'sine'
        lfo.frequency.value = Number(inputs['shift'].value) / 100
        let lfoGain = audioctx.createGain()
        lfoGain.gain.value = 0.01
        let lfo2 = audioctx.createOscillator()
        lfo2.type = 'sine'
        lfo2.frequency.value = Number(inputs['lfoRate'].value)
        let lfo2Gain = audioctx.createGain()
        lfo2Gain.gain.value = Number(inputs['lfoDepth'].value) * 0.01
        let delayOffset = audioctx.createConstantSource()
        delayOffset.offset.value = 0.05
        lfo.connect(lfoGain)
        lfo2.connect(lfo2Gain)
        delayOffset.connect(delay.delayTime)
        lfoGain.connect(delay.delayTime)
        lfo2Gain.connect(delay.delayTime)
        input.connect(delay)
        delay.connect(wet)
        let feedbackGain = audioctx.createGain()
        feedbackGain.gain.value = Number(inputs['feedback'].value) * 0.5
        wet.connect(feedbackGain)
        feedbackGain.connect(delay)
        input.connect(dry)
        dry.gain.value = 1 - Number(inputs['mix'].value)
        wet.gain.value = Number(inputs['mix'].value)
        dry.connect(output)
        wet.connect(output)
        lfo.start()
        lfo2.start()
        delayOffset.start()
        inputs['shift'].addEventListener('change', () => {
            lfo.frequency.value = Number(inputs['shift'].value) / 100
        })
        inputs['feedback'].addEventListener('change', () => {
            feedbackGain.gain.value = Number(inputs['feedback'].value) * 0.5
        })
        inputs['lfoRate'].addEventListener('change', () => {
            lfo2.frequency.value = Number(inputs['lfoRate'].value)
        })
        inputs['lfoDepth'].addEventListener('change', () => {
            lfo2Gain.gain.value = Number(inputs['lfoDepth'].value) * 0.01
        })
        inputs['mix'].addEventListener('change', () => {
            dry.gain.value = 1 - Number(inputs['mix'].value)
            wet.gain.value = Number(inputs['mix'].value)
        })
        return {
            input: input,
            output: output,
            params: {
                'shift': { node: lfo.frequency, transform: v => Number(v) / 100 },
                'feedback': { node: feedbackGain.gain, transform: v => Number(v) * 0.5 },
                'lfoRate': { node: lfo2.frequency, transform: v => Number(v) },
                'lfoDepth': { node: lfo2Gain.gain, transform: v => Number(v) * 0.01 },
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                lfo.stop()
                lfo2.stop()
                delayOffset.stop()
                lfo.disconnect()
                lfo2.disconnect()
                delayOffset.disconnect()
                lfoGain.disconnect()
                lfo2Gain.disconnect()
                input.disconnect()
                output.disconnect()
                wet.disconnect()
                dry.disconnect()
                delay.disconnect()
                feedbackGain.disconnect()
            }
        }
    },

    gate: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let bufferSize = 4096
        let sidechainFilter = audioctx.createBiquadFilter()
        sidechainFilter.type = 'bandpass'
        sidechainFilter.frequency.value = Number(inputs['sidechainFreq'].value)
        sidechainFilter.Q.value = 1
        let gateProcessor = audioctx.createScriptProcessor(bufferSize, 2, 1)
        let currentGain = 1
        let holdCounter = 0
        let sampleRate = audioctx.sampleRate
        gateProcessor.onaudioprocess = (e) => {
            let audioIn = e.inputBuffer.getChannelData(0)
            let scIn = e.inputBuffer.getChannelData(1)
            let out = e.outputBuffer.getChannelData(0)
            let threshold = Math.pow(10, Number(inputs['threshold'].value) / 20)
            let ratio = Number(inputs['ratio'].value)
            let attackTime = Number(inputs['attack'].value) / 1000
            let releaseTime = Number(inputs['release'].value) / 1000
            let holdTime = Number(inputs['hold'].value) / 1000
            let attackCoeff = Math.exp(-1 / (sampleRate * attackTime))
            let releaseCoeff = Math.exp(-1 / (sampleRate * releaseTime))
            let holdSamples = holdTime * sampleRate
            for (let i = 0; i < audioIn.length; i++) {
                let scLevel = Math.abs(scIn[i])
                let targetGain
                if (scLevel > threshold) {
                    targetGain = 1
                    holdCounter = holdSamples
                } else {
                    if (holdCounter > 0) {
                        targetGain = currentGain
                        holdCounter--
                    } else {
                        let expansion = threshold / (scLevel + 0.0001)
                        let gainReduction = Math.pow(expansion, 1 / ratio - 1)
                        targetGain = Math.min(1, gainReduction)
                    }
                }
                if (targetGain > currentGain) {
                    currentGain = targetGain + attackCoeff * (currentGain - targetGain)
                } else {
                    currentGain = targetGain + releaseCoeff * (currentGain - targetGain)
                }
                out[i] = audioIn[i] * currentGain
            }
        }
        let splitter = audioctx.createChannelSplitter(2)
        let merger = audioctx.createChannelMerger(2)
        input.connect(splitter)
        input.connect(sidechainFilter)
        splitter.connect(merger, 0, 0)
        sidechainFilter.connect(merger, 0, 1)
        merger.connect(gateProcessor)
        gateProcessor.connect(output)
        inputs['sidechainFreq'].addEventListener('change', () => {
            sidechainFilter.frequency.value = Number(inputs['sidechainFreq'].value)
        })
        return {
            input: input,
            output: output,
            params: {
                'sidechainFreq': { node: sidechainFilter.frequency, transform: v => Number(v) },
            },
            destroy: () => {
                input.disconnect()
                output.disconnect()
                sidechainFilter.disconnect()
                gateProcessor.disconnect()
                splitter.disconnect()
                merger.disconnect()
            }
        }
    },

    glitchdelay: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let delay = audioctx.createDelay(0.5)
        delay.delayTime.value = 0.05
        let feedbackGain = audioctx.createGain()
        feedbackGain.gain.value = Number(inputs['feedback'] ? inputs['feedback'].value : 0.3)
        let lfo = audioctx.createOscillator()
        let lfoGain = audioctx.createGain()
        lfo.type = 'sine'
        lfo.frequency.value = Number(inputs['pitchLfoFreq'] ? inputs['pitchLfoFreq'].value : 5)
        lfoGain.gain.value = Number(inputs['pitchLfoDepth'] ? inputs['pitchLfoDepth'].value : 0.2)
        lfo.connect(lfoGain)
        let wetGain = audioctx.createGain()
        wetGain.gain.value = Number(inputs['mix'] ? inputs['mix'].value : 0.5)
        let dryGain = audioctx.createGain()
        dryGain.gain.value = 1 - wetGain.gain.value
        input.connect(dryGain)
        input.connect(delay)
        delay.connect(feedbackGain)
        feedbackGain.connect(delay)
        delay.connect(wetGain)
        wetGain.connect(output)
        dryGain.connect(output)
        lfoGain.connect(delay.delayTime)
        lfo.start()
        ;['pitchLfoFreq','pitchLfoDepth','feedback','mix'].forEach(id => {
            if(inputs[id]){
                inputs[id].addEventListener('change', () => {
                    const val = Number(inputs[id].value)
                    switch(id){
                        case 'pitchLfoFreq': lfo.frequency.value = val; break
                        case 'pitchLfoDepth': lfoGain.gain.value = val; break
                        case 'feedback': feedbackGain.gain.value = val; break
                        case 'mix':
                            wetGain.gain.value = val
                            dryGain.gain.value = 1 - val
                            break
                    }
                })
            }
        })
        return {
            input: input,
            output: output,
            params: {
                'pitchLfoFreq': { node: lfo.frequency, transform: v => Number(v) },
                'pitchLfoDepth': { node: lfoGain.gain, transform: v => Number(v) },
                'feedback': { node: feedbackGain.gain, transform: v => Number(v) },
                'mix': [
                    { node: wetGain.gain, transform: v => Number(v) },
                    { node: dryGain.gain, transform: v => 1 - Number(v) },
                ],
            },
            destroy: () => {
                input.disconnect()
                output.disconnect()
                delay.disconnect()
                feedbackGain.disconnect()
                wetGain.disconnect()
                dryGain.disconnect()
                lfo.disconnect()
                lfoGain.disconnect()
            }
        }
    },

    granularpitch: (audioctx, inputs) => {
        const WORKLET_NAME = 'granular-pitch-stutter'
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let workletNode = null
        const WORKLET_LOADED_FLAG = '__granularPitchStutterLoaded__'
        const workletSrc = `
        class GranularPitchProcessor extends AudioWorkletProcessor {
          static get parameterDescriptors() {
            return [
              {name:'grainSize', defaultValue:30, minValue:10, maxValue:100, automationRate:'k-rate'},
              {name:'pitchShift', defaultValue:1, minValue:0.5, maxValue:2, automationRate:'k-rate'},
              {name:'feedback', defaultValue:0.3, minValue:0, maxValue:0.95, automationRate:'k-rate'},
              {name:'mix', defaultValue:0.5, minValue:0, maxValue:1, automationRate:'k-rate'}
            ]
          }
          constructor() {
            super()
            this.sampleRate = sampleRate
            this.buffers = []
            this.readPositions = []
          }
          process(inputs, outputs, parameters) {
            const inChs = inputs[0] || []
            const outChs = outputs[0] || []
            if(!inChs.length || !outChs.length) return true
            const blockSize = inChs[0].length
            const grainSizeMs = parameters.grainSize.length>0 ? parameters.grainSize[0] : 30
            const pitchShift = parameters.pitchShift.length>0 ? parameters.pitchShift[0] : 1
            const feedback = parameters.feedback.length>0 ? parameters.feedback[0] : 0.3
            const mix = parameters.mix.length>0 ? parameters.mix[0] : 0.5
            const grainSamples = Math.max(1, Math.floor(grainSizeMs*this.sampleRate/1000))
            for(let ch=0; ch<outChs.length; ch++){
              const inCh = inChs[ch] || inChs[0]
              const outCh = outChs[ch]
              if(!this.buffers[ch]) this.buffers[ch] = []
              if(this.readPositions[ch] === undefined) this.readPositions[ch] = 0
              const buf = this.buffers[ch]
              let readPos = this.readPositions[ch]
              for(let i=0;i<blockSize;i++){
                const x = inCh[i] || 0
                const feedbackSample = buf.length>0 ? buf[0]*feedback : 0
                buf.push(x + feedbackSample)
                let y = 0
                const floatPos = readPos
                const i0 = Math.floor(floatPos)
                const i1 = i0+1
                const frac = floatPos - i0
                const s0 = buf[i0] || 0
                const s1 = buf[i1] || 0
                y = s0*(1-frac) + s1*frac
                outCh[i] = y*mix + x*(1-mix)
                readPos += pitchShift
                if(readPos >= grainSamples){
                  buf.splice(0, Math.floor(readPos))
                  readPos -= Math.floor(readPos)
                }
              }
              this.readPositions[ch] = readPos
            }
            return true
          }
        }
        try{ registerProcessor('${WORKLET_NAME}', GranularPitchProcessor) }catch(e){}
        `
        const blobUrl = URL.createObjectURL(new Blob([workletSrc], {type:'application/javascript'}))
        const ensureWorklet = async () => {
            if(audioctx[WORKLET_LOADED_FLAG]) return
            await audioctx.audioWorklet.addModule(blobUrl)
            audioctx[WORKLET_LOADED_FLAG] = true
        }
        const ready = ensureWorklet().then(() => {
            workletNode = new AudioWorkletNode(audioctx, WORKLET_NAME, {
                numberOfInputs:1,
                numberOfOutputs:1,
                outputChannelCount:[2],
                parameterData:{
                    grainSize: Number(inputs['grainSize'] ? inputs['grainSize'].value : 30),
                    pitchShift: Number(inputs['pitchShift'] ? inputs['pitchShift'].value : 1),
                    feedback: Number(inputs['feedback'] ? inputs['feedback'].value : 0.3),
                    mix: Number(inputs['mix'] ? inputs['mix'].value : 0.5)
                }
            })
            input.connect(workletNode)
            workletNode.connect(output)
            ;['grainSize','pitchShift','feedback','mix'].forEach(id => {
                if(inputs[id]){
                    inputs[id].addEventListener('change', () => {
                        if(!workletNode) return
                        const p = workletNode.parameters.get(id)
                        if(p) p.setValueAtTime(Number(inputs[id].value), audioctx.currentTime)
                    })
                }
            })
        })
        return {
            input: input,
            output: output,
            ready: ready,
            params: {
                'grainSize': { get node() { return workletNode ? workletNode.parameters.get('grainSize') : null }, transform: v => Number(v) },
                'pitchShift': { get node() { return workletNode ? workletNode.parameters.get('pitchShift') : null }, transform: v => Number(v) },
                'feedback': { get node() { return workletNode ? workletNode.parameters.get('feedback') : null }, transform: v => Number(v) },
                'mix': { get node() { return workletNode ? workletNode.parameters.get('mix') : null }, transform: v => Number(v) },
            },
            destroy: () => {
                input.disconnect()
                output.disconnect()
                if(workletNode){ workletNode.disconnect(); workletNode = null }
                URL.revokeObjectURL(blobUrl)
                try{ delete audioctx[WORKLET_LOADED_FLAG] }catch(e){}
            }
        }
    },

    moogfilter: (audioctx, inputs) => {
        const WORKLET_NAME = 'moog-processor'
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let moog = null
        const WORKLET_LOADED_FLAG = '__moogProcessorLoaded__'
        const workletSrc = `
        class MoogProcessor extends AudioWorkletProcessor {
          static get parameterDescriptors() {
            return [
              { name: 'cutoff', minValue: 0, maxValue: 1, defaultValue: 0.065 },
              { name: 'resonance', minValue: 0, maxValue: 4, defaultValue: 0 }
            ]
          }
          constructor(options) {
            super(options)
            this.in1=0.0; this.in2=0.0; this.in3=0.0; this.in4=0.0
            this.out1=0.0; this.out2=0.0; this.out3=0.0; this.out4=0.0
          }
          process(inputs, outputs, parameters) {
            try {
              let input = inputs[0]
              let output = outputs[0]
              let f = Number(parameters['cutoff'][0]) * 1.16
              let fb = Number(parameters["resonance"][0]) * (1.0 - 0.15 * f * f)
              for (let channel = 0; channel < input.length; ++channel) {
                for (let i = 0; i < input[channel].length; ++i) {
                  input[channel][i] -= this.out4 * fb
                  input[channel][i] *= 0.35013 * (f * f) * (f * f)
                  this.out1 = input[channel][i] + 0.3 * this.in1 + (1 - f) * this.out1
                  this.in1 = input[channel][i]
                  this.out2 = this.out1 + 0.3 * this.in2 + (1 - f) * this.out2
                  this.in2 = this.out1
                  this.out3 = this.out2 + 0.3 * this.in3 + (1 - f) * this.out3
                  this.in3 = this.out2
                  this.out4 = this.out3 + 0.3 * this.in4 + (1 - f) * this.out4
                  this.in4 = this.out3
                  output[channel][i] = this.out4
                }
              }
            } catch (e) { console.error(e) }
            return true
          }
        }
        try{ registerProcessor('${WORKLET_NAME}', MoogProcessor) }catch(e){}
        `
        const blobUrl = URL.createObjectURL(new Blob([workletSrc], {type:'application/javascript'}))
        const ensureWorklet = async () => {
            if(audioctx[WORKLET_LOADED_FLAG]) return
            await audioctx.audioWorklet.addModule(blobUrl)
            audioctx[WORKLET_LOADED_FLAG] = true
        }
        const ready = ensureWorklet().then(() => {
            moog = new AudioWorkletNode(audioctx, WORKLET_NAME, {
                parameterData: {
                    cutoff: Number(inputs['cutoff'].value),
                    resonance: Number(inputs['resonance'].value)
                }
            })
            const cutoff = moog.parameters.get('cutoff')
            const resonance = moog.parameters.get('resonance')
            inputs['cutoff'].addEventListener('change', () => {
                if (!moog) return
                cutoff.setValueAtTime(Number(inputs['cutoff'].value), audioctx.currentTime)
            })
            inputs['resonance'].addEventListener('change', () => {
                if (!moog) return
                resonance.setValueAtTime(Number(inputs['resonance'].value), audioctx.currentTime)
            })
            input.connect(moog)
            moog.connect(output)
        }).catch(e => console.error(e))
        return {
            input: input,
            output: output,
            ready: ready,
            params: {
                'cutoff': { get node() { return moog ? moog.parameters.get('cutoff') : null }, transform: v => Number(v) },
                'resonance': { get node() { return moog ? moog.parameters.get('resonance') : null }, transform: v => Number(v) },
            },
            destroy: () => {
                input.disconnect()
                output.disconnect()
                if(moog){ moog.disconnect(); moog = null }
                URL.revokeObjectURL(blobUrl)
                try{ delete audioctx[WORKLET_LOADED_FLAG] }catch(e){}
            }
        }
    },

    noiseverb: (audioctx, inputs) => {
        function createPerlinNoise(audioContext, bufferSize) {
            let perlin = {
                rand_vect: function () {
                    let theta = Math.random() * 2 * Math.PI
                    return { x: Math.cos(theta), y: Math.sin(theta) }
                },
                dot_prod_grid: function (x, y, vx, vy) {
                    let g_vect
                    let d_vect = { x: x - vx, y: y - vy }
                    if (this.gradients[[vx, vy]]) {
                        g_vect = this.gradients[[vx, vy]]
                    } else {
                        g_vect = this.rand_vect()
                        this.gradients[[vx, vy]] = g_vect
                    }
                    return d_vect.x * g_vect.x + d_vect.y * g_vect.y
                },
                smootherstep: function (x) {
                    return 6 * x ** 5 - 15 * x ** 4 + 10 * x ** 3
                },
                interp: function (x, a, b) {
                    return a + this.smootherstep(x) * (b - a)
                },
                seed: function () {
                    this.gradients = {}
                    this.memory = {}
                },
                get: function (x, y) {
                    if (this.memory.hasOwnProperty([x, y])) return this.memory[[x, y]]
                    let xf = Math.floor(x)
                    let yf = Math.floor(y)
                    let tr = this.dot_prod_grid(x, y, xf + 1, yf)
                    let tl = this.dot_prod_grid(x, y, xf, yf)
                    let bl = this.dot_prod_grid(x, y, xf, yf + 1)
                    let br = this.dot_prod_grid(x, y, xf + 1, yf + 1)
                    let xt = this.interp(x - xf, tl, tr)
                    let xb = this.interp(x - xf, bl, br)
                    let v = this.interp(y - yf, xt, xb)
                    this.memory[[x, y]] = v
                    return v
                }
            }
            perlin.seed()
            let buffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate),
                output = buffer.getChannelData(0)
            for (let i = 0; i < bufferSize; i++) {
                output[i] = perlin.get(i / bufferSize, 0)
            }
            return buffer
        }
        function createWhiteNoise(audioContext, bufferSize) {
            let buffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate),
                output = buffer.getChannelData(0)
            for (let i = 0; i < bufferSize; i++) {
                output[i] = Math.random() * 2 - 1
            }
            return buffer
        }
        function createPinkNoise(audioContext, bufferSize) {
            let b0, b1, b2, b3, b4, b5, b6
            b0 = b1 = b2 = b3 = b4 = b5 = b6 = 0.0
            let buffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate),
                output = buffer.getChannelData(0)
            for (let i = 0; i < bufferSize; i++) {
                let white = Math.random() * 2 - 1
                b0 = 0.99886 * b0 + white * 0.0555179
                b1 = 0.99332 * b1 + white * 0.0750759
                b2 = 0.96900 * b2 + white * 0.1538520
                b3 = 0.86650 * b3 + white * 0.3104856
                b4 = 0.55000 * b4 + white * 0.5329522
                b5 = -0.7616 * b5 - white * 0.0168980
                output[i] = b0 + b1 + b2 + b3 + b4 + b5 + b6 + white * 0.5362
                output[i] *= 0.11
                b6 = white * 0.115926
            }
            return buffer
        }
        function createBrownNoise(audioContext, bufferSize) {
            let lastOut = 0.0
            let buffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate),
                output = buffer.getChannelData(0)
            for (let i = 0; i < bufferSize; i++) {
                let white = Math.random() * 2 - 1
                output[i] = (lastOut + (0.02 * white)) / 1.02
                lastOut = output[i]
                output[i] *= 3.5
            }
            return buffer
        }
        function createBlueNoise(audioContext, bufferSize) {
            let b0 = 0.0, b1 = 0.0, b2 = 0.0
            let buffer = audioContext.createBuffer(1, bufferSize, audioContext.sampleRate),
                output = buffer.getChannelData(0)
            for (let i = 0; i < bufferSize; i++) {
                let white = Math.random() * 2 - 1
                b0 = 0.05 * white + b1
                b1 = b0
                output[i] = b0 * 3.5
            }
            return buffer
        }
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let reverbdry = audioctx.createGain()
        let reverbwet = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        let convolver = audioctx.createConvolver()
        async function setBuffer(value) {
            let bufSize = 2 * audioctx.sampleRate
            switch (Number(value)) {
                case 0: convolver.buffer = createWhiteNoise(audioctx, bufSize); break
                case 1: convolver.buffer = createPinkNoise(audioctx, bufSize); break
                case 2: convolver.buffer = createBrownNoise(audioctx, bufSize); break
                case 3: convolver.buffer = createBlueNoise(audioctx, bufSize); break
                case 4: convolver.buffer = createPerlinNoise(audioctx, bufSize); break
                default: convolver.buffer = createWhiteNoise(audioctx, bufSize)
            }
        }
        inputs['type'].addEventListener('change', () => {
            setBuffer(inputs['type'].value)
        })
        setBuffer(inputs['type'].value)
        input.connect(convolver)
        input.connect(reverbdry)
        convolver.connect(reverbwet)
        reverbdry.connect(output)
        reverbwet.connect(output)
        updator.onaudioprocess = () => {
            if (reverbdry) {
                reverbdry.gain.setValueAtTime(1 - inputs['dry_wet'].value, audioctx.currentTime)
            }
            if (reverbwet) {
                reverbwet.gain.setValueAtTime(inputs['dry_wet'].value, audioctx.currentTime)
            }
        }
        return {
            input: input,
            output: output,
            params: {
                'dry_wet': [
                    { node: reverbdry.gain, transform: v => 1 - v },
                    { node: reverbwet.gain, transform: v => v },
                ],
            },
            destroy: () => {
                updator.disconnect()
                sink.disconnect()
                input.disconnect()
                output.disconnect()
                convolver.disconnect()
                reverbdry.disconnect()
                reverbwet.disconnect()
            }
        }
    },

    phaser: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let wet = audioctx.createGain()
        let dry = audioctx.createGain()
        let lfo = audioctx.createOscillator()
        lfo.type = 'sine'
        lfo.frequency.value = Number(inputs['rate'].value)
        let lfoGain = audioctx.createGain()
        lfoGain.gain.value = Number(inputs['depth'].value) * 1000
        let stages = Math.floor(Number(inputs['stages'].value))
        let allpassFilters = []
        for (let i = 0; i < stages; i++) {
            let allpass = audioctx.createBiquadFilter()
            allpass.type = 'allpass'
            allpass.frequency.value = 500 + i * 200
            allpass.Q.value = 1
            allpassFilters.push(allpass)
        }
        let feedbackGain = audioctx.createGain()
        feedbackGain.gain.value = Number(inputs['feedback'].value)
        lfo.connect(lfoGain)
        for (let i = 0; i < allpassFilters.length; i++) {
            lfoGain.connect(allpassFilters[i].frequency)
        }
        input.connect(dry)
        input.connect(allpassFilters[0])
        for (let i = 0; i < allpassFilters.length - 1; i++) {
            allpassFilters[i].connect(allpassFilters[i + 1])
        }
        allpassFilters[allpassFilters.length - 1].connect(wet)
        allpassFilters[allpassFilters.length - 1].connect(feedbackGain)
        feedbackGain.connect(allpassFilters[0])
        dry.gain.value = 1 - Number(inputs['mix'].value)
        wet.gain.value = Number(inputs['mix'].value)
        dry.connect(output)
        wet.connect(output)
        lfo.start()
        inputs['rate'].addEventListener('change', () => {
            lfo.frequency.value = Number(inputs['rate'].value)
        })
        inputs['depth'].addEventListener('change', () => {
            lfoGain.gain.value = Number(inputs['depth'].value) * 1000
        })
        inputs['feedback'].addEventListener('change', () => {
            feedbackGain.gain.value = Number(inputs['feedback'].value)
        })
        inputs['mix'].addEventListener('change', () => {
            dry.gain.value = 1 - Number(inputs['mix'].value)
            wet.gain.value = Number(inputs['mix'].value)
        })
        return {
            input: input,
            output: output,
            params: {
                'rate': { node: lfo.frequency, transform: v => Number(v) },
                'depth': { node: lfoGain.gain, transform: v => Number(v) * 1000 },
                'feedback': { node: feedbackGain.gain, transform: v => Number(v) },
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                lfo.stop()
                lfo.disconnect()
                lfoGain.disconnect()
                input.disconnect()
                output.disconnect()
                wet.disconnect()
                dry.disconnect()
                feedbackGain.disconnect()
                allpassFilters.forEach(f => f.disconnect())
            }
        }
    },

    resonantFilterBank: (audioctx, inputs) => {
        const ctrlmap = {
            'LP_88hz': '0', '125Hz': '1', '175Hz': '2', '250Hz': '3',
            '350Hz': '4', '500Hz': '5', '750Hz': '6', '1k': '7',
            '1_4k': '8', '2k': '9', '2_8k': '10', '4k': '11',
            '5_6k': '12', 'HP_7k': '13'
        }
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let compressor = audioctx.createDynamicsCompressor()
        let wetGain = audioctx.createGain()
        let dryGain = audioctx.createGain()
        let filters = []
        let gainStages = []
        wetGain.gain.setValueAtTime(0, audioctx.currentTime)
        dryGain.gain.setValueAtTime(1, audioctx.currentTime)
        compressor.threshold.setValueAtTime(-56, audioctx.currentTime)
        compressor.connect(wetGain)
        input.connect(dryGain)
        wetGain.connect(output)
        dryGain.connect(output)
        let bands = [0, 37, 50, 75, 100, 250, 250, 250, 400, 600, 800, 1200, 1600, 1400]
        let baseFreq = 88
        let baseQ = 400
        for (let i = 0; i < bands.length; i++) {
            let band = bands[i]
            let filter = audioctx.createBiquadFilter()
            let filterType = 'bandpass'
            let freq = baseFreq + band
            let q = baseQ
            let gain = 0
            if (i == 0 || i == (bands.length - 1)) {
                q = 30
                filterType = (i == 0) ? 'lowpass' : 'highpass'
            } else {
                gain = 20
            }
            filter.type = filterType
            filter.gain.setValueAtTime(gain, audioctx.currentTime)
            filter.Q.setValueAtTime(q, audioctx.currentTime)
            filter.frequency.setValueAtTime(freq, audioctx.currentTime)
            input.connect(filter)
            let gainStage = audioctx.createGain()
            gainStage.gain.setValueAtTime(0, audioctx.currentTime)
            gainStage.connect(compressor)
            filter.connect(gainStage)
            filters.push(filter)
            gainStages.push(gainStage)
        }
        let filterBank = { filters, gainStages, wetGain, dryGain, compressor }
        let filterGainHandler = function(e, idx) {
            let fraction = parseFloat(e.value) / parseFloat(e.max),
                factor = Math.pow(fraction, 2),
                gainStage = filterBank.gainStages[idx]
            gainStage.gain.setValueAtTime(factor, audioctx.currentTime)
        }
        let wetDryHandler = function(e) {
            let val = parseFloat(e.value),
                max = parseFloat(e.max),
                fraction = parseFloat(val / max),
                wetFactor = Math.pow(fraction, 2),
                dryFactor = Math.pow((1 - fraction), 2)
            if (val == 0) { wetFactor = 0; dryFactor = 1 }
            else if (val == 1) { wetFactor = 1; dryFactor = 0 }
            filterBank.wetGain.gain.setValueAtTime(wetFactor, audioctx.currentTime)
            filterBank.dryGain.gain.setValueAtTime(dryFactor, audioctx.currentTime)
        }
        for (let key in inputs) {
            inputs[key].addEventListener('change', function(e) {
                if (key === 'dryWet') {
                    wetDryHandler(e.target)
                } else {
                    filterGainHandler(e.target, ctrlmap[key])
                }
            })
        }
        return {
            input: input,
            output: output,
            params: {
                'LP_88hz': { node: gainStages[0].gain, transform: v => Math.pow(v, 2) },
                '125Hz': { node: gainStages[1].gain, transform: v => Math.pow(v, 2) },
                '175Hz': { node: gainStages[2].gain, transform: v => Math.pow(v, 2) },
                '250Hz': { node: gainStages[3].gain, transform: v => Math.pow(v, 2) },
                '350Hz': { node: gainStages[4].gain, transform: v => Math.pow(v, 2) },
                '500Hz': { node: gainStages[5].gain, transform: v => Math.pow(v, 2) },
                '750Hz': { node: gainStages[6].gain, transform: v => Math.pow(v, 2) },
                '1k': { node: gainStages[7].gain, transform: v => Math.pow(v, 2) },
                '1_4k': { node: gainStages[8].gain, transform: v => Math.pow(v, 2) },
                '2k': { node: gainStages[9].gain, transform: v => Math.pow(v, 2) },
                '2_8k': { node: gainStages[10].gain, transform: v => Math.pow(v, 2) },
                '4k': { node: gainStages[11].gain, transform: v => Math.pow(v, 2) },
                '5_6k': { node: gainStages[12].gain, transform: v => Math.pow(v, 2) },
                'HP_7k': { node: gainStages[13].gain, transform: v => Math.pow(v, 2) },
                'dryWet': [
                    { node: wetGain.gain, transform: v => v == 0 ? 0 : v == 1 ? 1 : Math.pow(v, 2) },
                    { node: dryGain.gain, transform: v => v == 0 ? 1 : v == 1 ? 0 : Math.pow(1 - v, 2) },
                ],
            },
            destroy: () => {
                input.disconnect()
                output.disconnect()
                compressor.disconnect()
                wetGain.disconnect()
                dryGain.disconnect()
                filters.forEach(f => f.disconnect())
                gainStages.forEach(g => g.disconnect())
            }
        }
    },

    spectralfreeze: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let wet = audioctx.createGain()
        let dry = audioctx.createGain()
        let bufferSize = 8192
        let freezeProcessor = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let frozenBuffer = new Float32Array(bufferSize * 4)
        let isFrozen = false
        let readPos = 0
        let writePos = 0
        let fadeProgress = 0
        let sampleRate = audioctx.sampleRate
        let decayGain = 1.0
        freezeProcessor.onaudioprocess = (e) => {
            let inp = e.inputBuffer.getChannelData(0)
            let out = e.outputBuffer.getChannelData(0)
            let fadeTime = Number(inputs['fadeTime'].value) / 1000
            let fadeSamples = fadeTime * sampleRate
            let decayAmount = Number(inputs['decay'].value)
            let shimmerAmount = Number(inputs['shimmer'].value)
            for (let i = 0; i < inp.length; i++) {
                if (!isFrozen) {
                    frozenBuffer[writePos] = inp[i]
                    writePos = (writePos + 1) % frozenBuffer.length
                    out[i] = inp[i]
                } else {
                    let frozen = frozenBuffer[readPos]
                    if (shimmerAmount > 0) {
                        let shimmerPos = Math.floor(readPos * 0.5) % frozenBuffer.length
                        frozen = frozen * (1 - shimmerAmount) + frozenBuffer[shimmerPos] * shimmerAmount
                    }
                    frozen *= decayGain
                    if (fadeProgress < fadeSamples) {
                        let fadeMix = fadeProgress / fadeSamples
                        out[i] = inp[i] * (1 - fadeMix) + frozen * fadeMix
                        fadeProgress++
                    } else {
                        out[i] = frozen
                    }
                    readPos = (readPos + 1) % frozenBuffer.length
                    decayGain *= (1 - decayAmount * 0.00001)
                    if (decayGain < 0.001) decayGain = 0.001
                }
            }
        }
        inputs['freeze'].addEventListener('change', () => {
            let shouldFreeze = Number(inputs['freeze'].value) > 0.5
            if (shouldFreeze && !isFrozen) {
                isFrozen = true
                readPos = 0
                fadeProgress = 0
                decayGain = 1.0
            } else if (!shouldFreeze && isFrozen) {
                isFrozen = false
                fadeProgress = 0
            }
        })
        input.connect(dry)
        input.connect(freezeProcessor)
        freezeProcessor.connect(wet)
        dry.gain.value = 1 - Number(inputs['mix'].value)
        wet.gain.value = Number(inputs['mix'].value)
        dry.connect(output)
        wet.connect(output)
        inputs['mix'].addEventListener('change', () => {
            dry.gain.value = 1 - Number(inputs['mix'].value)
            wet.gain.value = Number(inputs['mix'].value)
        })
        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                input.disconnect()
                output.disconnect()
                wet.disconnect()
                dry.disconnect()
                freezeProcessor.disconnect()
            }
        }
    },

    stereowidener: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let bufferSize = 4096
        let processor = audioctx.createScriptProcessor(bufferSize, 2, 2)
        let delayTime = Number(inputs['delay'].value) / 1000
        let delaySamples = Math.floor(delayTime * audioctx.sampleRate)
        let delayBuffer = new Float32Array(delaySamples)
        let delayPos = 0
        processor.onaudioprocess = (e) => {
            let inL = e.inputBuffer.getChannelData(0)
            let inR = e.inputBuffer.getChannelData(1)
            let outL = e.outputBuffer.getChannelData(0)
            let outR = e.outputBuffer.getChannelData(1)
            let width = Number(inputs['width'].value)
            for (let i = 0; i < inL.length; i++) {
                let left = inL[i]
                let right = inR[i]
                let mid = (left + right) * 0.5
                let side = (left - right) * 0.5
                if (delaySamples > 0) {
                    delayBuffer[delayPos] = side
                    side = delayBuffer[delayPos]
                    delayPos = (delayPos + 1) % delaySamples
                }
                side *= width
                outL[i] = mid + side
                outR[i] = mid - side
            }
        }
        input.connect(processor)
        processor.connect(output)
        inputs['delay'].addEventListener('change', () => {
            let newDelayTime = Number(inputs['delay'].value) / 1000
            let newDelaySamples = Math.floor(newDelayTime * audioctx.sampleRate)
            if (newDelaySamples !== delaySamples) {
                delaySamples = newDelaySamples
                delayBuffer = new Float32Array(delaySamples)
                delayPos = 0
            }
        })
        return {
            input: input,
            output: output,
            destroy: () => {
                input.disconnect()
                output.disconnect()
                processor.disconnect()
            }
        }
    },

    tapesaturation: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let wet = audioctx.createGain()
        let dry = audioctx.createGain()
        let bufferSize = 4096
        let preGain = audioctx.createGain()
        preGain.gain.value = 1
        let wowLfo = audioctx.createOscillator()
        wowLfo.type = 'sine'
        wowLfo.frequency.value = 0.5
        let wowGain = audioctx.createGain()
        wowGain.gain.value = Number(inputs['wow'].value) * 0.02
        let flutterLfo = audioctx.createOscillator()
        flutterLfo.type = 'sine'
        flutterLfo.frequency.value = 8
        let flutterGain = audioctx.createGain()
        flutterGain.gain.value = Number(inputs['flutter'].value) * 0.01
        let delay = audioctx.createDelay(0.1)
        delay.delayTime.value = 0.02
        let delayOffset = audioctx.createConstantSource()
        delayOffset.offset.value = 0.02
        wowLfo.connect(wowGain)
        flutterLfo.connect(flutterGain)
        delayOffset.connect(delay.delayTime)
        wowGain.connect(delay.delayTime)
        flutterGain.connect(delay.delayTime)
        let saturationProcessor = audioctx.createScriptProcessor(bufferSize, 1, 1)
        saturationProcessor.onaudioprocess = (e) => {
            let inp = e.inputBuffer.getChannelData(0)
            let out = e.outputBuffer.getChannelData(0)
            let sat = Number(inputs['saturation'].value)
            let bias = Number(inputs['bias'].value) * 0.2
            let drive = Number(inputs['drive'].value)
            for (let i = 0; i < inp.length; i++) {
                let x = inp[i] * drive
                x = x + bias
                let saturated
                if (Math.abs(x) < 0.3) {
                    saturated = x
                } else {
                    let sign = x > 0 ? 1 : -1
                    let abs = Math.abs(x)
                    saturated = sign * (0.3 + (1 - 0.3) * Math.tanh((abs - 0.3) * sat * 3))
                }
                saturated = saturated * (1 - sat * 0.3) + Math.tanh(x * 2) * sat * 0.3
                out[i] = saturated * 0.8
            }
        }
        let lowpass = audioctx.createBiquadFilter()
        lowpass.type = 'lowpass'
        lowpass.frequency.value = 8000
        lowpass.Q.value = 0.5
        let highpass = audioctx.createBiquadFilter()
        highpass.type = 'highpass'
        highpass.frequency.value = 40
        highpass.Q.value = 0.5
        let warmth = audioctx.createBiquadFilter()
        warmth.type = 'lowshelf'
        warmth.frequency.value = 200
        warmth.gain.value = 2
        input.connect(dry)
        dry.connect(output)
        input.connect(preGain)
        preGain.connect(delay)
        delay.connect(saturationProcessor)
        saturationProcessor.connect(highpass)
        highpass.connect(lowpass)
        lowpass.connect(warmth)
        warmth.connect(wet)
        wet.connect(output)
        let mixValue = Number(inputs['mix'].value)
        dry.gain.value = 1 - mixValue
        wet.gain.value = mixValue
        wowLfo.start()
        flutterLfo.start()
        delayOffset.start()
        inputs['wow'].addEventListener('change', () => {
            wowGain.gain.value = Number(inputs['wow'].value) * 0.02
        })
        inputs['flutter'].addEventListener('change', () => {
            flutterGain.gain.value = Number(inputs['flutter'].value) * 0.01
        })
        inputs['mix'].addEventListener('change', () => {
            let mix = Number(inputs['mix'].value)
            dry.gain.value = 1 - mix
            wet.gain.value = mix
        })
        return {
            input: input,
            output: output,
            params: {
                'wow': { node: wowGain.gain, transform: v => Number(v) * 0.02 },
                'flutter': { node: flutterGain.gain, transform: v => Number(v) * 0.01 },
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                wowLfo.stop()
                flutterLfo.stop()
                delayOffset.stop()
                wowLfo.disconnect()
                flutterLfo.disconnect()
                delayOffset.disconnect()
                wowGain.disconnect()
                flutterGain.disconnect()
                input.disconnect()
                output.disconnect()
                wet.disconnect()
                dry.disconnect()
                preGain.disconnect()
                delay.disconnect()
                saturationProcessor.disconnect()
                lowpass.disconnect()
                highpass.disconnect()
                warmth.disconnect()
            }
        }
    },

    // Phase vocoder pitch shift (SMB/Bernsee method) — ported from audiojs/shift-pvoc.
    // Computes true instantaneous frequency per bin from consecutive-frame phase advance,
    // shifts bins to the destination implied by `ratio`, accumulates synthesis phase at
    // the shifted frequency, and reconstructs via overlap-add ISTFT. Higher quality than
    // the granular `pitshifter`: preserves dominant-partial pitch and long-horizon phase
    // per bin. MIT licensed upstream (audiojs/shift).
    pvshift: (audioctx, inputs) => {
        // --- radix-2 FFT (in-place, iterative) ---
        function fft(re, im, inverse) {
            const n = re.length
            // bit-reversal permutation
            for (let i = 1, j = 0; i < n; i++) {
                let bit = n >> 1
                for (; j & bit; bit >>= 1) j ^= bit
                j ^= bit
                if (i < j) {
                    let t = re[i]; re[i] = re[j]; re[j] = t
                    t = im[i]; im[i] = im[j]; im[j] = t
                }
            }
            for (let len = 2; len <= n; len <<= 1) {
                const ang = (inverse ? 2 : -2) * Math.PI / len
                const wRe = Math.cos(ang), wIm = Math.sin(ang)
                for (let i = 0; i < n; i += len) {
                    let cRe = 1, cIm = 0
                    for (let k = 0; k < len / 2; k++) {
                        const uRe = re[i + k], uIm = im[i + k]
                        const vRe = re[i + k + len / 2] * cRe - im[i + k + len / 2] * cIm
                        const vIm = re[i + k + len / 2] * cIm + im[i + k + len / 2] * cRe
                        re[i + k] = uRe + vRe
                        im[i + k] = uIm + vIm
                        re[i + k + len / 2] = uRe - vRe
                        im[i + k + len / 2] = uIm - vIm
                        const nRe = cRe * wRe - cIm * wIm
                        cIm = cRe * wIm + cIm * wRe
                        cRe = nRe
                    }
                }
            }
            if (inverse) {
                for (let i = 0; i < n; i++) { re[i] /= n; im[i] /= n }
            }
        }

        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let processor = null

        // State — rebuilt when grain size changes
        let frameSize, hopSize, half
        let hann, synWindow, inBuf, outBuf
        let prevPhase, sumPhase, omega
        let re, im, mag, phase, newMag, newPhase
        let inFifo, outFifo, inFifoRead, inFifoWrite, outFifoRead, outFifoWrite

        function setup(frameSz) {
            frameSize = frameSz
            hopSize = frameSize / 4  // 4x overlap (75%)
            half = frameSize / 2

            // Hann analysis window
            hann = new Float32Array(frameSize)
            for (let i = 0; i < frameSize; i++) {
                hann[i] = 0.5 * (1 - Math.cos(2 * Math.PI * i / (frameSize - 1)))
            }

            // COLA normalization: sum of hann^2 over 4 overlapping frames.
            // Compute numerically (handles symmetric-window edge effects safely.)
            let colaMax = 0
            for (let i = 0; i < hopSize; i++) {
                let s = 0
                for (let k = 0; k * hopSize < frameSize; k++) {
                    const idx = i + k * hopSize
                    if (idx >= 0 && idx < frameSize) s += hann[idx] * hann[idx]
                }
                if (s > colaMax) colaMax = s
            }
            // Synthesis window = hann / colaMax  (ensures unity COLA gain)
            synWindow = new Float32Array(frameSize)
            for (let i = 0; i < frameSize; i++) synWindow[i] = hann[i] / colaMax

            // Sliding input window + output overlap-add buffer
            inBuf = new Float32Array(frameSize)
            outBuf = new Float32Array(frameSize)

            // Phase vocoder state
            prevPhase = new Float32Array(half + 1)
            sumPhase = new Float32Array(half + 1)
            omega = new Float32Array(half + 1)
            for (let k = 0; k <= half; k++) {
                omega[k] = 2 * Math.PI * k * hopSize / frameSize
            }

            // Scratch arrays
            re = new Float32Array(frameSize)
            im = new Float32Array(frameSize)
            mag = new Float32Array(half + 1)
            phase = new Float32Array(half + 1)
            newMag = new Float32Array(half + 1)
            newPhase = new Float32Array(half + 1)

            // FIFOs bridging the fixed-size ScriptProcessor callback and the
            // hop-sized PV frame processing. Sized generously to never overflow
            // between callbacks (processor buffer = 256, hopSize <= 1024).
            inFifo = new Float32Array(frameSize + 1024)
            outFifo = new Float32Array(frameSize + 1024)
            inFifoRead = 0; inFifoWrite = 0
            outFifoRead = 0; outFifoWrite = 0
            // Mark FIFOs empty
            inFifo.fill(0); outFifo.fill(0)
        }

        // Process one hopSize chunk: slide input window by hopSize using samples
        // already in inBuf's tail, run analysis-synthesis, push hopSize outputs.
        function processHop(pitchRatio) {
            // --- Analysis: window + FFT ---
            for (let j = 0; j < frameSize; j++) {
                re[j] = inBuf[j] * hann[j]
                im[j] = 0
            }
            fft(re, im, false)

            // Magnitude & phase for first half+1 bins
            for (let k = 0; k <= half; k++) {
                mag[k] = Math.sqrt(re[k] * re[k] + im[k] * im[k])
                phase[k] = Math.atan2(im[k], re[k])
            }

            // --- Phase vocoder: instantaneous freq estimation + bin shift ---
            newMag.fill(0)
            newPhase.fill(0)
            for (let k = 0; k <= half; k++) {
                // Phase deviation from expected advance
                let delta = phase[k] - prevPhase[k] - omega[k]
                // Wrap to [-pi, pi]
                delta = delta - 2 * Math.PI * Math.round(delta / (2 * Math.PI))
                // Destination bin
                const idx = Math.round(k * pitchRatio)
                if (idx >= 0 && idx <= half) {
                    // Magnitude: loudest contributor wins (scatterGated convention)
                    if (mag[k] > newMag[idx]) newMag[idx] = mag[k]
                    // Synthesis phase advances at the SHIFTED frequency:
                    //   pitchRatio * (omega[k] + delta)  [rad per hop]
                    sumPhase[idx] += pitchRatio * (omega[k] + delta)
                    newPhase[idx] = sumPhase[idx]
                }
                prevPhase[k] = phase[k]
            }

            // --- Reconstruct spectrum (Hermitian symmetry for real output) ---
            for (let k = 0; k <= half; k++) {
                re[k] = newMag[k] * Math.cos(newPhase[k])
                im[k] = newMag[k] * Math.sin(newPhase[k])
            }
            for (let k = half + 1; k < frameSize; k++) {
                const m = frameSize - k
                re[k] = re[m]
                im[k] = -im[m]
            }

            // --- IFFT ---
            fft(re, im, true)

            // --- Synthesis: shift output buffer, overlap-add windowed frame ---
            for (let i = 0; i < frameSize - hopSize; i++) {
                outBuf[i] = outBuf[i + hopSize]
            }
            for (let i = frameSize - hopSize; i < frameSize; i++) {
                outBuf[i] = 0
            }
            for (let j = 0; j < frameSize; j++) {
                outBuf[j] += re[j] * synWindow[j]
            }

            // --- Push first hopSize samples (fully overlap-added) to outFifo ---
            for (let i = 0; i < hopSize; i++) {
                outFifo[outFifoWrite] = outBuf[i]
                outFifoWrite = (outFifoWrite + 1) % outFifo.length
            }
        }

        function buildProcessor() {
            if (processor) {
                input.disconnect()
                processor.disconnect()
            }
            setup(Number(inputs['grain'].value))
            // ScriptProcessor bufferSize must be a power of 2 in [256, 16384].
            // Use a fixed 256 and bridge to hopSize via internal FIFOs.
            processor = audioctx.createScriptProcessor(256, 1, 1)

            processor.onaudioprocess = function (event) {
                const inputData = event.inputBuffer.getChannelData(0)
                const outputData = event.outputBuffer.getChannelData(0)
                const pitchRatio = Number(inputs['ratio'].value)
                const len = inputData.length

                // 1. Push incoming samples into inFifo
                for (let i = 0; i < len; i++) {
                    inFifo[inFifoWrite] = inputData[i]
                    inFifoWrite = (inFifoWrite + 1) % inFifo.length
                }

                // 2. Process PV frames while enough new input is available.
                //    inBuf needs `frameSize` samples; we slide it left by hopSize
                //    and pull hopSize new samples from inFifo per frame.
                let avail = (inFifoWrite - inFifoRead + inFifo.length) % inFifo.length
                while (avail >= hopSize) {
                    // Slide inBuf left by hopSize
                    for (let i = 0; i < frameSize - hopSize; i++) {
                        inBuf[i] = inBuf[i + hopSize]
                    }
                    // Pull hopSize new samples from inFifo into inBuf tail
                    for (let i = 0; i < hopSize; i++) {
                        inBuf[frameSize - hopSize + i] = inFifo[inFifoRead]
                        inFifoRead = (inFifoRead + 1) % inFifo.length
                    }
                    avail -= hopSize
                    processHop(pitchRatio)
                }

                // 3. Read `len` samples from outFifo into outputData.
                //    On underflow (startup latency), output silence.
                let outAvail = (outFifoWrite - outFifoRead + outFifo.length) % outFifo.length
                for (let i = 0; i < len; i++) {
                    if (outAvail > 0) {
                        outputData[i] = outFifo[outFifoRead]
                        outFifoRead = (outFifoRead + 1) % outFifo.length
                        outAvail--
                    } else {
                        outputData[i] = 0
                    }
                }
            }

            input.connect(processor)
            processor.connect(output)
        }

        inputs['grain'].addEventListener('change', buildProcessor)
        buildProcessor()

        return {
            input,
            output,
            destroy: () => {
                input.disconnect()
                input = null
                output.disconnect()
                output = null
                if (processor) { processor.disconnect(); processor = null }
            }
        }
    },

    // Procedural IR reverb — ported from logue/Reverb.js (MIT).
    // Generates a stereo impulse response from colored noise with exponential
    // decay, optional pre-delay, reverse, and a biquad filter on the wet chain.
    // More parameters than `noiseverb`: decay power, pre-delay, IR time, reverse,
    // filter type/freq/Q, and noise color.
    procreverb: (audioctx, inputs) => {
        // --- colored noise generators (single-channel, length samples) ---
        function whiteNoise(len) {
            const buf = new Float32Array(len)
            for (let i = 0; i < len; i++) buf[i] = Math.random() * 2 - 1
            return buf
        }
        function pinkNoise(len) {
            const buf = new Float32Array(len)
            let b0 = 0, b1 = 0, b2 = 0, b3 = 0, b4 = 0, b5 = 0, b6 = 0
            for (let i = 0; i < len; i++) {
                const w = Math.random() * 2 - 1
                b0 = 0.99886 * b0 + w * 0.0555179
                b1 = 0.99332 * b1 + w * 0.0750759
                b2 = 0.96900 * b2 + w * 0.1538520
                b3 = 0.86650 * b3 + w * 0.3104856
                b4 = 0.55000 * b4 + w * 0.5329522
                b5 = -0.7616 * b5 - w * 0.0168980
                buf[i] = (b0 + b1 + b2 + b3 + b4 + b5 + b6 + w * 0.5362) * 0.11
                b6 = w * 0.115926
            }
            return buf
        }
        function brownNoise(len) {
            const buf = new Float32Array(len)
            let last = 0
            for (let i = 0; i < len; i++) {
                const w = Math.random() * 2 - 1
                buf[i] = (last + 0.02 * w) / 1.02
                last = buf[i]
                buf[i] *= 3.5
            }
            return buf
        }
        function blueNoise(len) {
            const buf = new Float32Array(len)
            let b0 = 0, b1 = 0, b2 = 0
            for (let i = 0; i < len; i++) {
                const w = Math.random() * 2 - 1
                b0 = 0.05 * w + b1
                b1 = b0
                b2 = 0.6 * b2 + 0.4 * b0
                buf[i] = (b0 - b2) * 2.5
            }
            return buf
        }

        function buildImpulse() {
            const rate = audioctx.sampleRate
            const time = Number(inputs['time'].value)
            const decay = Number(inputs['decay'].value)
            const delay = Number(inputs['delay'].value)
            const reverse = Number(inputs['reverse'].value) === 1
            const noiseType = Number(inputs['noise'].value)
            const duration = Math.max(Math.floor(rate * time), 1)
            const delayDuration = Math.max(0, Math.floor(rate * delay))
            const impulse = audioctx.createBuffer(2, duration, rate)
            const noiseL = noiseType === 1 ? pinkNoise(duration)
                : noiseType === 2 ? brownNoise(duration)
                : noiseType === 3 ? blueNoise(duration)
                : whiteNoise(duration)
            const noiseR = noiseType === 1 ? pinkNoise(duration)
                : noiseType === 2 ? brownNoise(duration)
                : noiseType === 3 ? blueNoise(duration)
                : whiteNoise(duration)
            const impulseL = new Float32Array(duration)
            const impulseR = new Float32Array(duration)
            for (let i = 0; i < duration; i++) {
                let decayIndex
                if (i < delayDuration) {
                    decayIndex = reverse ? duration - (i - delayDuration) : i - delayDuration
                } else {
                    decayIndex = reverse ? duration - i : i
                }
                const decayLevel = Math.max(0, 1 - decayIndex / duration)
                impulseL[i] = noiseL[i] * Math.pow(decayLevel, decay)
                impulseR[i] = noiseR[i] * Math.pow(decayLevel, decay)
            }
            impulse.getChannelData(0).set(impulseL)
            impulse.getChannelData(1).set(impulseR)
            convolver.buffer = impulse
        }

        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let convolver = audioctx.createConvolver()
        let filter = audioctx.createBiquadFilter()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        input.connect(dry)
        input.connect(convolver)
        convolver.connect(filter)
        filter.connect(wet)
        dry.connect(output)
        wet.connect(output)

        // Apply initial filter settings
        filter.type = inputs['filterType'].value
        filter.frequency.value = Number(inputs['filterFreq'].value)
        filter.Q.value = Number(inputs['filterQ'].value)

        // Initial mix
        dry.gain.value = 1 - Number(inputs['mix'].value)
        wet.gain.value = Number(inputs['mix'].value)

        buildImpulse()

        // Rebuild IR when IR-shaping params change
        inputs['time'].addEventListener('change', buildImpulse)
        inputs['decay'].addEventListener('change', buildImpulse)
        inputs['delay'].addEventListener('change', buildImpulse)
        inputs['reverse'].addEventListener('change', buildImpulse)
        inputs['noise'].addEventListener('change', buildImpulse)

        // Filter params update live (no IR rebuild)
        inputs['filterType'].addEventListener('change', () => {
            filter.type = inputs['filterType'].value
        })
        inputs['filterFreq'].addEventListener('change', () => {
            filter.frequency.setValueAtTime(Number(inputs['filterFreq'].value), audioctx.currentTime)
        })
        inputs['filterQ'].addEventListener('change', () => {
            filter.Q.setValueAtTime(Number(inputs['filterQ'].value), audioctx.currentTime)
        })

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
                'filterFreq': { node: filter.frequency, transform: v => Number(v) },
                'filterQ': { node: filter.Q, transform: v => Number(v) },
            },
            destroy: () => {
                updator.disconnect()
                sink.disconnect()
                input.disconnect()
                output.disconnect()
                convolver.disconnect()
                filter.disconnect()
                dry.disconnect()
                wet.disconnect()
            }
        }
    },

    // ============ mdrone-ported effects ============

    // SHIMMER — pitch-shifted reverb shimmer (octave-up reverb feedback)
    // input → dry → output
    // input → convolver → pitchShift(×2) → feedback → convolver → wet → output
    shimmer: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let feedbackGain = audioctx.createGain()
        let convolver = audioctx.createConvolver()
        let pitchShift = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let pitchOut = audioctx.createGain()
        let pitchIn = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        // Generate shimmer IR (bright, medium-long)
        function makeIR() {
            const rate = audioctx.sampleRate
            const len = Math.floor(rate * 3.5)
            const buf = audioctx.createBuffer(2, len, rate)
            for (let c = 0; c < 2; c++) {
                const d = buf.getChannelData(c)
                for (let i = 0; i < len; i++) {
                    d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2.5)
                }
            }
            return buf
        }
        convolver.buffer = makeIR()

        // Simple delay-based pitch shifter (octave up)
        // Uses two crossfading delay read heads at half the delay time
        let psBuf = new Float32Array(audioctx.sampleRate * 2)
        let psWriteIdx = 0
        let psPhase = 0
        pitchShift.onaudioprocess = (evt) => {
            const ib = evt.inputBuffer.getChannelData(0)
            const ob = evt.outputBuffer.getChannelData(0)
            const ratio = 2.0 // octave up
            const delaySamples = 2048
            for (let s = 0; s < ib.length; s++) {
                psBuf[psWriteIdx] = ib[s]
                psWriteIdx = (psWriteIdx + 1) % psBuf.length
                // Two read heads at half-speed to double frequency
                psPhase += ratio
                const phase0 = psPhase % delaySamples
                const phase1 = (psPhase + delaySamples / 2) % delaySamples
                const readIdx0 = (psWriteIdx - 1 - Math.floor(phase0) + psBuf.length) % psBuf.length
                const readIdx1 = (psWriteIdx - 1 - Math.floor(phase1) + psBuf.length) % psBuf.length
                // Crossfade envelope
                const env = Math.abs((psPhase % delaySamples) / delaySamples * 2 - 1)
                ob[s] = psBuf[readIdx0] * env + psBuf[readIdx1] * (1 - env)
            }
        }

        // Wiring
        input.connect(dry)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        input.connect(convolver)
        convolver.connect(pitchIn)
        pitchIn.connect(pitchShift)
        pitchShift.connect(pitchOut)
        pitchOut.connect(wet)
        pitchOut.connect(feedbackGain)
        feedbackGain.connect(convolver)
        dry.connect(output)
        wet.connect(output)

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            const fb = Number(inputs['feedback'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
            feedbackGain.gain.setValueAtTime(fb, audioctx.currentTime)
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
                'feedback': { node: feedbackGain.gain, transform: v => Number(v) },
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
                convolver.disconnect(); feedbackGain.disconnect()
                pitchIn.disconnect(); pitchShift.disconnect(); pitchOut.disconnect()
            }
        }
    },

    // FREEZE — phase-vocoder magnitude-hold capture
    // Captures a window of audio and loops it continuously (spectral freeze)
    // size    : 0..1   — fraction of the captured buffer that loops (1 = full 2s, 0.01 = ~20ms grain)
    // position: 0..1   — start offset of the loop window within the captured buffer
    freeze: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        const captureLen = Math.floor(audioctx.sampleRate * 2)
        let captureBuf = new Float32Array(captureLen)
        let writeIdx = 0
        let frozen = false
        let readIdx = 0
        // Loop window — derived from size/position knobs, updated live
        let loopStart = 0
        let loopLen = captureLen

        function updateWindow() {
            const size = Math.max(0.005, Math.min(1, Number(inputs['size'].value)))
            const pos = Math.max(0, Math.min(1, Number(inputs['position'].value)))
            loopLen = Math.max(32, Math.floor(captureLen * size))
            const maxStart = captureLen - loopLen
            loopStart = Math.floor(pos * maxStart)
        }
        updateWindow()

        let processor = audioctx.createScriptProcessor(bufferSize, 1, 1)
        processor.onaudioprocess = (evt) => {
            const ib = evt.inputBuffer.getChannelData(0)
            const ob = evt.outputBuffer.getChannelData(0)
            if (!frozen) {
                // Record input
                for (let s = 0; s < ib.length; s++) {
                    captureBuf[writeIdx] = ib[s]
                    writeIdx = (writeIdx + 1) % captureLen
                }
            } else {
                // Live-update the loop window so size/position changes are audible
                updateWindow()
            }
            // Play back the loop window (loopStart .. loopStart+loopLen) repeatedly
            for (let s = 0; s < ob.length; s++) {
                ob[s] = captureBuf[loopStart + readIdx]
                readIdx++
                if (readIdx >= loopLen) readIdx = 0
            }
        }

        input.connect(dry)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        input.connect(processor)
        processor.connect(wet)
        dry.connect(output)
        wet.connect(output)

        // Freeze trigger button — inputs['freeze'] is a knob 0/1
        inputs['freeze'].addEventListener('change', () => {
            if (Number(inputs['freeze'].value) === 1) {
                frozen = true
                // Snap the loop window to the most recently captured audio:
                // writeIdx is where the next sample would land, so the freshest
                // window ends just behind it. Anchor loopStart so the loop covers
                // the latest `loopLen` samples captured.
                updateWindow()
                const end = writeIdx           // next write position = freshest sample + 1
                let start = end - loopLen
                if (start < 0) start += captureLen
                // Only use this anchor if it describes a contiguous captured region
                // (i.e. we've wrapped at most once). Otherwise fall back to the
                // position-knob-derived start.
                if (start >= 0 && start < captureLen) {
                    loopStart = start
                }
                readIdx = 0
            } else {
                frozen = false
            }
        })

        // Live size/position tweaks while frozen are handled in onaudioprocess above,
        // but also update immediately on change for responsiveness.
        inputs['size'].addEventListener('change', updateWindow)
        inputs['position'].addEventListener('change', () => {
            updateWindow()
            // Re-anchor read position relative to the new window start
            if (frozen) readIdx = readIdx % loopLen
        })

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
                processor.disconnect()
            }
        }
    },

    // HALO — harmonic exciter / partial bloom
    // Splits input into 3 bands, generates upper harmonics in each band via
    // waveshaping (full-wave rectification + soft clip), then mixes the
    // harmonic-rich output back. tilt controls band balance (bright/dark).
    halo: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        // 3 bands: low (200-800Hz), mid (800-3000Hz), high (3000-12000Hz)
        const bandCfg = [
            { type: 'bandpass', freq: 500, q: 0.7 },
            { type: 'bandpass', freq: 1600, q: 0.7 },
            { type: 'highpass', freq: 3000, q: 0.7 },
        ]

        // Harmonic generation curve — full-wave rect + soft clip
        // This generates strong 2x, 3x, 4x harmonics from any input
        function harmonicCurve() {
            const n = 2048
            const c = new Float32Array(n)
            for (let i = 0; i < n; i++) {
                const x = i * 2 / n - 1
                // Full-wave rectification: abs(x) generates even harmonics
                // Add a cubic term for odd harmonics → rich spectrum
                const rect = Math.abs(x)
                const cubic = x * x * x * 0.3
                c[i] = Math.tanh(3 * (rect + cubic)) / Math.tanh(3)
            }
            return c
        }

        const bands = bandCfg.map((cfg, i) => {
            const filter = audioctx.createBiquadFilter()
            filter.type = cfg.type
            filter.frequency.value = cfg.freq
            filter.Q.value = cfg.q

            // Harmonic generator — waveshaper with rectification curve
            const shaper = audioctx.createWaveShaper()
            shaper.curve = harmonicCurve()
            shaper.oversample = '4x'

            // Band gain (tilt-controlled)
            const bandGain = audioctx.createGain()
            bandGain.gain.value = 1 / (i + 1)

            input.connect(filter)
            filter.connect(shaper)
            shaper.connect(bandGain)
            bandGain.connect(wet)

            return { filter, shaper, bandGain }
        })

        input.connect(dry)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        dry.connect(output)
        wet.connect(output)

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            const tilt = Number(inputs['tilt'].value) // -1 = dark, 0 = flat, 1 = bright
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
            bands.forEach((b, i) => {
                // tilt > 0 boosts high bands, tilt < 0 boosts low bands
                const base = 1 / (i + 1)
                const t = tilt > 0
                    ? base * Math.pow(1 + i * 0.8, tilt * 2)
                    : base * Math.pow(1 + (bands.length - i) * 0.8, -tilt * 2)
                b.bandGain.gain.setValueAtTime(t, audioctx.currentTime)
            })
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
                bands.forEach(b => {
                    b.filter.disconnect(); b.shaper.disconnect(); b.bandGain.disconnect()
                })
            }
        }
    },

    // SUB — subharmonic synthesizer FX
    // Tracks the input pitch via autocorrelation, generates a sub oscillator
    // whose amplitude follows the input envelope. No input = no output (it's
    // an FX, not a standalone synth). The input gates the sub so it only
    // speaks when there's signal, and the sub amplitude tracks the input
    // loudness in real time — like a vocoder imposing the input's envelope
    // onto a sub-bass carrier.
    sub: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        let subProc = audioctx.createScriptProcessor(bufferSize, 1, 1)

        // --- State ---
        let detectedFreq = 110     // smoothed pitch estimate
        let rawFreq = 110          // raw autocorrelation result
        let envLevel = 0           // smoothed input envelope
        let subPhase = 0           // sub oscillator phase [0..1)
        let corrBuf = new Float32Array(2048) // ring buffer for autocorrelation

        // Autocorrelation pitch detection — much more stable than zero-crossing.
        // Searches lag range corresponding to 50Hz..2000Hz.
        function detectPitch(buf, sr) {
            const minLag = Math.floor(sr / 2000) // 50Hz upper bound
            const maxLag = Math.floor(sr / 50)   // 50Hz lower bound
            const len = Math.min(buf.length, maxLag)
            let bestLag = 0
            let bestCorr = 0
            for (let lag = minLag; lag <= maxLag && lag < len; lag++) {
                let corr = 0
                for (let i = 0; i < len - lag; i++) {
                    corr += buf[i] * buf[i + lag]
                }
                corr /= (len - lag)
                if (corr > bestCorr) {
                    bestCorr = corr
                    bestLag = lag
                }
            }
            if (bestLag > 0 && bestCorr > 0.01) {
                return sr / bestLag
            }
            return 0 // no reliable pitch
        }

        subProc.onaudioprocess = (evt) => {
            const ib = evt.inputBuffer.getChannelData(0)
            const ob = evt.outputBuffer.getChannelData(0)
            const sr = audioctx.sampleRate
            const trackSpeed = 0.0005 + Number(inputs['tracking'].value) * 0.005
            const octave = Number(inputs['octave'].value) // 1 or 2
            const waveType = inputs['wave'].value

            // Copy into correlation ring buffer
            for (let s = 0; s < ib.length && s < corrBuf.length; s++) {
                corrBuf[s] = ib[s]
            }

            // Detect pitch once per block
            const detected = detectPitch(corrBuf, sr)
            if (detected > 0) {
                rawFreq = detected
            }

            // Smooth the pitch estimate to avoid jitter
            if (rawFreq > 0) {
                detectedFreq = detectedFreq * 0.92 + rawFreq * 0.08
            }

            // Compute sub frequency (1 or 2 octaves down)
            const subFreq = Math.max(15, detectedFreq / octave)

            // Per-sample: envelope follow + sub oscillator gated by envelope
            for (let s = 0; s < ib.length; s++) {
                const absSig = Math.abs(ib[s])
                // Envelope follower — attack/release governed by tracking knob
                if (absSig > envLevel) {
                    envLevel += (absSig - envLevel) * (trackSpeed * 20)
                } else {
                    envLevel += (absSig - envLevel) * trackSpeed
                }
                // Gate: sub only sounds when input is present
                const gate = envLevel > 0.005 ? 1 : 0
                // Advance sub oscillator phase
                subPhase += subFreq / sr
                subPhase = subPhase % 1
                // Waveform
                let wave
                if (waveType === 'sine') {
                    wave = Math.sin(subPhase * Math.PI * 2)
                } else if (waveType === 'triangle') {
                    wave = subPhase < 0.5
                        ? (subPhase * 4 - 1)
                        : (3 - subPhase * 4)
                } else if (waveType === 'square') {
                    wave = subPhase < 0.5 ? 1 : -1
                } else { // saw
                    wave = subPhase * 2 - 1
                }
                // Sub amplitude = input envelope (vocoder-like: input shapes the sub)
                ob[s] = wave * envLevel * 2.5 * gate
            }
        }

        input.connect(dry)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        input.connect(subProc)
        subProc.connect(wet)
        dry.connect(output)
        wet.connect(output)

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
                subProc.disconnect()
            }
        }
    },

    // TAPE — saturation + head bump + top-end rolloff
    tape: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        // Saturation curve
        function makeCurve(drive) {
            const k = drive * 50
            const n = 22050
            const curve = new Float32Array(n)
            for (let i = 0; i < n; i++) {
                const x = i * 2 / n - 1
                curve[i] = Math.tanh(k * x) / Math.tanh(k)
            }
            return curve
        }

        let shaper = audioctx.createWaveShaper()
        shaper.curve = makeCurve(0.5)
        shaper.oversample = '4x'

        // Head bump — low shelf boost around 100Hz
        let headBump = audioctx.createBiquadFilter()
        headBump.type = 'lowshelf'
        headBump.frequency.value = 120
        headBump.gain.value = 4

        // Top-end rolloff — lowpass around 8kHz
        let rolloff = audioctx.createBiquadFilter()
        rolloff.type = 'lowpass'
        rolloff.frequency.value = 8000
        rolloff.Q.value = 0.7

        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        input.connect(headBump)
        headBump.connect(shaper)
        shaper.connect(rolloff)
        rolloff.connect(output)

        updator.onaudioprocess = () => {
            const drive = Number(inputs['drive'].value)
            const bump = Number(inputs['bump'].value)
            const rolloffFreq = Number(inputs['rolloff'].value)
            headBump.gain.setValueAtTime(bump, audioctx.currentTime)
            rolloff.frequency.setValueAtTime(rolloffFreq, audioctx.currentTime)
            // Rebuild curve only when drive changes significantly
            if (shaper) {
                shaper.curve = makeCurve(drive)
            }
        }

        return {
            input: input,
            output: output,
            params: {
                'bump': { node: headBump.gain, transform: v => Number(v) },
                'rolloff': { node: rolloff.frequency, transform: v => Number(v) },
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                shaper.disconnect(); headBump.disconnect(); rolloff.disconnect()
            }
        }
    },

    // COMB — root-tracking resonant comb with soft-clipped feedback
    comb: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let feedback = audioctx.createGain()
        let delay = audioctx.createDelay(0.1)
        let softClip = audioctx.createWaveShaper()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        // Soft clip curve
        function softCurve() {
            const n = 1024
            const c = new Float32Array(n)
            for (let i = 0; i < n; i++) {
                const x = i * 2 / n - 1
                c[i] = Math.tanh(3 * x) / Math.tanh(3)
            }
            return c
        }
        softClip.curve = softCurve()

        input.connect(dry)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        input.connect(delay)
        delay.connect(softClip)
        softClip.connect(feedback)
        feedback.connect(delay)
        delay.connect(wet)
        dry.connect(output)
        wet.connect(output)

        updator.onaudioprocess = () => {
            const freq = Number(inputs['freq'].value)
            const fb = Number(inputs['feedback'].value)
            const mix = Number(inputs['mix'].value)
            // Delay time = 1/freq (comb root tracking)
            const dt = Math.max(0.0001, 1 / Math.max(20, freq))
            delay.delayTime.setValueAtTime(dt, audioctx.currentTime)
            feedback.gain.setValueAtTime(fb, audioctx.currentTime)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
        }

        return {
            input: input,
            output: output,
            params: {
                'feedback': { node: feedback.gain, transform: v => Number(v) },
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
                delay.disconnect(); feedback.disconnect(); softClip.disconnect()
            }
        }
    },

    // FORMANT — vowel formant filter (peaking filters in series)
    // Boosts F1/F2/F3 formant frequencies on the input signal, coloring it
    // with vowel characteristics. Unlike bandpass, the full signal passes
    // through with the formant frequencies emphasized — like a vocal EQ.
    formant: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        // Vowel formant frequency sets [F1, F2, F3] with gains in dB
        const VOWELS = {
            'ah': [[800, 12], [1150, 8], [2900, 4]],
            'ee': [[270, 14], [2300, 10], [3000, 6]],
            'ih': [[400, 12], [1900, 8], [2550, 4]],
            'eh': [[530, 12], [1840, 8], [2480, 4]],
            'oh': [[570, 12], [840, 8], [2410, 4]],
            'oo': [[300, 14], [870, 8], [2240, 4]],
            'uh': [[640, 12], [1190, 8], [2390, 4]],
        }

        // 3 peaking filters in series — the signal passes through all 3,
        // getting each formant frequency boosted
        const formants = [0, 1, 2].map(() => {
            const pk = audioctx.createBiquadFilter()
            pk.type = 'peaking'
            pk.frequency.value = 800
            pk.Q.value = 8
            pk.gain.value = 12 // boost in dB
            return pk
        })
        // Wire in series: input → formant[0] → formant[1] → formant[2] → wet
        input.connect(formants[0])
        formants[0].connect(formants[1])
        formants[1].connect(formants[2])
        formants[2].connect(wet)

        function setVowel(v) {
            const cfg = VOWELS[v] || VOWELS['ah']
            cfg.forEach(([f, gainDb], i) => {
                formants[i].frequency.setValueAtTime(f, audioctx.currentTime)
                formants[i].gain.setValueAtTime(gainDb, audioctx.currentTime)
            })
        }
        setVowel(inputs['vowel'].value)
        inputs['vowel'].addEventListener('change', () => setVowel(inputs['vowel'].value))

        input.connect(dry)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        dry.connect(output)
        wet.connect(output)

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            const q = Number(inputs['q'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
            formants.forEach(f => f.Q.setValueAtTime(q, audioctx.currentTime))
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
                'q': { node: formants[0].Q, transform: v => Number(v) },
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
                formants.forEach(f => f.disconnect())
            }
        }
    },

    // WOW — slow wow + faster flutter on a short delay line
    wow: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let delay = audioctx.createDelay(0.1)
        let wowLfo = audioctx.createOscillator()
        let wowDepth = audioctx.createGain()
        let flutterLfo = audioctx.createOscillator()
        let flutterDepth = audioctx.createGain()
        let baseDelay = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        wowLfo.type = 'sine'
        wowLfo.frequency.value = 0.7
        flutterLfo.type = 'sine'
        flutterLfo.frequency.value = 6
        wowDepth.gain.value = 0.005
        flutterDepth.gain.value = 0.0008
        delay.delayTime.value = 0.003

        wowLfo.connect(wowDepth)
        wowDepth.connect(delay.delayTime)
        flutterLfo.connect(flutterDepth)
        flutterDepth.connect(delay.delayTime)

        input.connect(dry)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        input.connect(delay)
        delay.connect(wet)
        dry.connect(output)
        wet.connect(output)

        wowLfo.start()
        flutterLfo.start()

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            const wowRate = Number(inputs['wowRate'].value)
            const wowAmt = Number(inputs['wowAmt'].value)
            const flutRate = Number(inputs['flutRate'].value)
            const flutAmt = Number(inputs['flutAmt'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
            wowLfo.frequency.setValueAtTime(wowRate, audioctx.currentTime)
            wowDepth.gain.setValueAtTime(wowAmt, audioctx.currentTime)
            flutterLfo.frequency.setValueAtTime(flutRate, audioctx.currentTime)
            flutterDepth.gain.setValueAtTime(flutAmt, audioctx.currentTime)
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
                'wowRate': { node: wowLfo.frequency, transform: v => Number(v) },
                'wowAmt': { node: wowDepth.gain, transform: v => Number(v) },
                'flutRate': { node: flutterLfo.frequency, transform: v => Number(v) },
                'flutAmt': { node: flutterDepth.gain, transform: v => Number(v) },
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
                delay.disconnect(); wowDepth.disconnect(); flutterDepth.disconnect()
                try { wowLfo.stop() } catch (e) {}
                try { flutterLfo.stop() } catch (e) {}
                wowLfo.disconnect(); flutterLfo.disconnect()
            }
        }
    },

    // HALL — Schroeder hall reverb (parallel combs + series allpasses)
    hall: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        // Schroeder reverb: 4 parallel comb filters → 2 series allpass
        const combDelays = [0.0297, 0.0371, 0.0411, 0.0437]
        const combFeedbacks = [0.84, 0.83, 0.82, 0.81]
        const allpassDelays = [0.005, 0.0017]
        const allpassFeedback = 0.7

        const combs = combDelays.map((dt, i) => {
            const d = audioctx.createDelay(dt + 0.01)
            d.delayTime.value = dt
            const fb = audioctx.createGain()
            fb.gain.value = combFeedbacks[i]
            d.connect(fb)
            fb.connect(d)
            input.connect(d)
            return { d, fb }
        })

        let allpassInput = audioctx.createGain()
        combs.forEach(c => c.d.connect(allpassInput))

        const allpasses = allpassDelays.map((dt, i) => {
            const d = audioctx.createDelay(dt + 0.01)
            d.delayTime.value = dt
            const fb = audioctx.createGain()
            fb.gain.value = allpassFeedback
            const ff = audioctx.createGain() // feedforward
            ff.gain.value = -allpassFeedback
            const sum = audioctx.createGain()
            const prev = i === 0 ? allpassInput : allpasses[i - 1].out
            prev.connect(d)
            d.connect(sum)
            d.connect(fb)
            fb.connect(d)
            prev.connect(ff)
            ff.connect(sum)
            return { d, fb, ff, sum, out: sum }
        })

        // allpasses[allpasses.length-1].out → wet
        if (allpasses.length > 0) {
            allpasses[allpasses.length - 1].out.connect(wet)
        }

        input.connect(dry)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        dry.connect(output)
        wet.connect(output)

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            const decay = Number(inputs['decay'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
            // Scale comb feedback by decay
            combs.forEach((c, i) => {
                c.fb.gain.setValueAtTime(combFeedbacks[i] * decay, audioctx.currentTime)
            })
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
                combs.forEach(c => { c.d.disconnect(); c.fb.disconnect() })
                allpassInput.disconnect()
                allpasses.forEach(a => { a.d.disconnect(); a.fb.disconnect(); a.ff.disconnect(); a.sum.disconnect() })
            }
        }
    },

    // CISTERN — very long cathedral-scale reverb (convolver with ~28s generated IR)
    cistern: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let convolver = audioctx.createConvolver()
        let dampFilter = audioctx.createBiquadFilter()
        dampFilter.type = 'lowpass'
        dampFilter.frequency.value = 2000
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        // Generate long cathedral IR
        function makeIR() {
            const rate = audioctx.sampleRate
            const seconds = Number(inputs['time'].value)
            const len = Math.floor(rate * seconds)
            const buf = audioctx.createBuffer(2, len, rate)
            for (let c = 0; c < 2; c++) {
                const d = buf.getChannelData(c)
                let prev = 0
                for (let i = 0; i < len; i++) {
                    // Diffuse noise with very slow exponential decay
                    const noise = Math.random() * 2 - 1
                    // Smooth the noise for a more "cistern" like dense tail
                    prev = prev * 0.99 + noise * 0.01
                    const decay = Math.pow(1 - i / len, 1.5)
                    d[i] = (noise * 0.7 + prev * 0.3) * decay
                }
            }
            return buf
        }
        convolver.buffer = makeIR()
        inputs['time'].addEventListener('change', () => {
            convolver.buffer = makeIR()
        })

        input.connect(dry)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        input.connect(convolver)
        convolver.connect(dampFilter)
        dampFilter.connect(wet)
        dry.connect(output)
        wet.connect(output)

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            const damp = Number(inputs['damp'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
            dampFilter.frequency.setValueAtTime(damp, audioctx.currentTime)
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
                'damp': { node: dampFilter.frequency, transform: v => Number(v) },
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
                convolver.disconnect(); dampFilter.disconnect()
            }
        }
    },

    // GRANULAR — drone-smooth grain cloud (envelope-sum normalised)
    granular: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        const bufLen = Math.floor(audioctx.sampleRate * 4)
        let recBuf = new Float32Array(bufLen)
        let recIdx = 0

        let grainProc = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let grains = []
        const maxGrains = 8
        let grainTimer = 0

        function spawnGrain() {
            const grainSize = Math.floor(audioctx.sampleRate * (0.05 + Math.random() * 0.15))
            const startPos = Math.floor(Math.random() * (bufLen - grainSize))
            const pitchShift = 0.5 + Math.random() * 1.5
            grains.push({
                pos: startPos,
                size: grainSize,
                readPos: 0,
                pitch: pitchShift,
                pan: Math.random() * 2 - 1,
                amp: 0.3 + Math.random() * 0.4,
            })
            if (grains.length > maxGrains) grains.shift()
        }

        grainProc.onaudioprocess = (evt) => {
            const ib = evt.inputBuffer.getChannelData(0)
            const ob = evt.outputBuffer.getChannelData(0)
            const density = Number(inputs['density'].value)
            const grainRate = Math.floor(audioctx.sampleRate / (density * 50 + 5))

            // Record input
            for (let s = 0; s < ib.length; s++) {
                recBuf[recIdx] = ib[s]
                recIdx = (recIdx + 1) % bufLen
            }

            // Spawn grains
            grainTimer += ib.length
            while (grainTimer >= grainRate) {
                spawnGrain()
                grainTimer -= grainRate
            }

            // Render grains with Hann window
            for (let s = 0; s < ob.length; s++) {
                let sum = 0
                for (let g of grains) {
                    if (g.readPos < g.size) {
                        const srcIdx = (g.pos + Math.floor(g.readPos)) % bufLen
                        const env = 0.5 - 0.5 * Math.cos(2 * Math.PI * g.readPos / g.size)
                        sum += recBuf[srcIdx] * env * g.amp
                        g.readPos += g.pitch
                    }
                }
                ob[s] = sum * 0.5
            }
            // Clean finished grains
            grains = grains.filter(g => g.readPos < g.size)
        }

        input.connect(dry)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        input.connect(grainProc)
        grainProc.connect(wet)
        dry.connect(output)
        wet.connect(output)

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
                grainProc.disconnect()
            }
        }
    },

    // GRAINCLOUD — classic 40ms grain stutter with pitch snapping
    graincloud: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        const bufLen = Math.floor(audioctx.sampleRate * 2)
        let recBuf = new Float32Array(bufLen)
        let recIdx = 0

        // Pitch ratios snapped to scale (semitones)
        const scaleSemitones = [0, 2, 4, 5, 7, 9, 11, 12, -12, -5, -7]
        let grainProc = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let currentGrain = null
        let grainTimer = 0

        function spawnGrain() {
            const grainSize = Math.floor(audioctx.sampleRate * 0.04) // 40ms
            const startPos = Math.floor(Math.random() * (bufLen - grainSize))
            const semitone = scaleSemitones[Math.floor(Math.random() * scaleSemitones.length)]
            const pitch = Math.pow(2, semitone / 12)
            currentGrain = {
                pos: startPos,
                size: grainSize,
                readPos: 0,
                pitch: pitch,
                amp: 0.5 + Math.random() * 0.3,
            }
        }

        grainProc.onaudioprocess = (evt) => {
            const ib = evt.inputBuffer.getChannelData(0)
            const ob = evt.outputBuffer.getChannelData(0)
            const rate = Number(inputs['rate'].value)
            const grainRate = Math.floor(audioctx.sampleRate / (rate * 100 + 10))

            for (let s = 0; s < ib.length; s++) {
                recBuf[recIdx] = ib[s]
                recIdx = (recIdx + 1) % bufLen
            }

            grainTimer += ib.length
            while (grainTimer >= grainRate) {
                spawnGrain()
                grainTimer -= grainRate
            }

            for (let s = 0; s < ob.length; s++) {
                let val = 0
                if (currentGrain && currentGrain.readPos < currentGrain.size) {
                    const srcIdx = (currentGrain.pos + Math.floor(currentGrain.readPos)) % bufLen
                    const env = 0.5 - 0.5 * Math.cos(2 * Math.PI * currentGrain.readPos / currentGrain.size)
                    val = recBuf[srcIdx] * env * currentGrain.amp
                    currentGrain.readPos += currentGrain.pitch
                }
                ob[s] = val
            }
        }

        input.connect(dry)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)
        input.connect(grainProc)
        grainProc.connect(wet)
        dry.connect(output)
        wet.connect(output)

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
                grainProc.disconnect()
            }
        }
    },

    // HRTF — binaural panner (hrtf-panner-js). Mono input → 3D stereo via Kemar HRIRs.
    hrtf: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        let panner = null
        let ready = false
        let lastAz = null, lastEl = null

        input.connect(dry)
        dry.connect(output)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)

        loadHrtfContainer().then(container => {
            try {
                panner = new window.HRTFPanner(audioctx, input, container)
                panner.connect(wet)
                wet.connect(output)
                ready = true
                const az = Number(inputs['azimuth'].value)
                const el = Number(inputs['elevation'].value)
                panner.update(az, el)
                lastAz = az; lastEl = el
            } catch (e) {
                console.error('HRTF init failed', e)
            }
        }).catch(e => console.error('HRTF load failed', e))

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
            if (ready && panner) {
                const az = Number(inputs['azimuth'].value)
                const el = Number(inputs['elevation'].value)
                if (az !== lastAz || el !== lastEl) {
                    panner.update(az, el)
                    lastAz = az; lastEl = el
                }
            }
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                ready = false
                panner = null
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
            }
        }
    },

    // BINAURALFIR — IRCAM binauralFIR (k-d tree nearest-neighbour + crossfade convolvers).
    // Different HRTF dataset (IRCAM) and interpolation vs the Kemar/Delaunay hrtf effect above.
    binauralfir: (audioctx, inputs) => {
        let input = audioctx.createGain()
        let output = audioctx.createGain()
        let dry = audioctx.createGain()
        let wet = audioctx.createGain()
        let updator = audioctx.createScriptProcessor(bufferSize, 1, 1)
        let sink = audioctx.createGain()
        sink.gain.value = 0

        let binauralNode = null
        let ready = false
        let lastAz = null, lastEl = null, lastDist = null

        input.connect(dry)
        dry.connect(output)
        input.connect(updator)
        updator.connect(sink)
        sink.connect(output)

        loadIrcamHrtfs().then(hrtfs => {
            try {
                // Build AudioBuffers from FIR coefficients.
                // Source dataset is 512 taps @ 44100 Hz; resample to the context rate
                // (ConvolverNode.buffer must match AudioContext.sampleRate).
                const ctxRate = audioctx.sampleRate
                const srcRate = 44100
                const srcLen = 512
                const dstLen = Math.round(srcLen * ctxRate / srcRate)
                const ratio = srcRate / ctxRate
                for (let i = 0; i < hrtfs.length; i++) {
                    if (hrtfs[i].buffer) continue
                    const buf = audioctx.createBuffer(2, dstLen, ctxRate)
                    const L = buf.getChannelData(0)
                    const R = buf.getChannelData(1)
                    const cl = hrtfs[i].fir_coeffs_left
                    const cr = hrtfs[i].fir_coeffs_right
                    // Linear interpolation resample (adequate for short HRIRs)
                    for (let e = 0; e < dstLen; e++) {
                        const srcPos = e * ratio
                        const i0 = Math.floor(srcPos)
                        const i1 = Math.min(i0 + 1, srcLen - 1)
                        const frac = srcPos - i0
                        L[e] = cl[i0] * (1 - frac) + cl[i1] * frac
                        R[e] = cr[i0] * (1 - frac) + cr[i1] * frac
                    }
                    hrtfs[i].buffer = buf
                }
                binauralNode = new window.BinauralFIR({ audioContext: audioctx })
                binauralNode.HRTFDataset = hrtfs
                input.connect(binauralNode.input)
                binauralNode.connect(wet)
                wet.connect(output)
                ready = true
                const az = Number(inputs['azimuth'].value)
                const el = Number(inputs['elevation'].value)
                const dist = Number(inputs['distance'].value)
                binauralNode.setPosition(az, el, dist)
                lastAz = az; lastEl = el; lastDist = dist
            } catch (e) {
                console.error('binauralFIR init failed', e)
            }
        }).catch(e => console.error('binauralFIR load failed', e))

        updator.onaudioprocess = () => {
            const mix = Number(inputs['mix'].value)
            dry.gain.setValueAtTime(1 - mix, audioctx.currentTime)
            wet.gain.setValueAtTime(mix, audioctx.currentTime)
            if (ready && binauralNode) {
                const az = Number(inputs['azimuth'].value)
                const el = Number(inputs['elevation'].value)
                const dist = Number(inputs['distance'].value)
                if (az !== lastAz || el !== lastEl || dist !== lastDist) {
                    binauralNode.setPosition(az, el, dist)
                    lastAz = az; lastEl = el; lastDist = dist
                }
            }
        }

        return {
            input: input,
            output: output,
            params: {
                'mix': [
                    { node: dry.gain, transform: v => 1 - Number(v) },
                    { node: wet.gain, transform: v => Number(v) },
                ],
            },
            destroy: () => {
                ready = false
                if (binauralNode) { try { binauralNode.disconnect() } catch (e) {} binauralNode = null }
                updator.disconnect(); sink.disconnect()
                input.disconnect(); output.disconnect()
                dry.disconnect(); wet.disconnect()
            }
        }
    },



}

module.exports = lib